import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  uz: {
    common: {
      language: 'Til',
      uzbek: 'Oʻzbekcha',
      russian: 'Русский',
      english: 'English',
      kazakh: 'Қазақша',
      cancel: 'Bekor qilish',
      save: 'Saqlash',
      confirm: 'Tasdiqlash',
      back: 'Orqaga',
      next: 'Keyingisi',
      delete: 'Oʻchirish',
      retry: 'Qayta urinish',
      loading: 'Yuklanmoqda',
      help: 'Yordam',
      errorGeneric: 'Xatolik yuz berdi',
      total: 'Jami',
      logout: 'Chiqish',
      loggedOut: 'Tizimdan chiqildi',
      loginSuccess: 'Tizimga muvaffaqiyatli kirildi',
      loginError: 'Tizimga kirishda xatolik',
      flutterBridgeMissing: 'Flutter koʻprigi mavjud emas',
      tokensSaved: 'Tokenlar saqlandi',
      errorBoundary: {
        title: 'Kutilmagan xatolik',
        description: 'Iltimos qaytadan urinib koʻring. Muammo davom etsa bosh sahifaga qayting.',
        retry: 'Qayta urinish',
        goHome: 'Bosh sahifaga qaytish',
      },
    },
    nav: {
      parcels: 'Posilkalar',
      parcelsShort: 'Posilkalar',
      packages: 'Paketlar',
      create: 'Yangi posilka',
      createShort: 'Yaratish',
      claim: 'Kuzatishga qoʻshish',
      claimShort: 'Qidirish',
      track: 'Kuzatish',
      ids: 'Cargo ID',
      support: 'Yordam',
      settings: 'Sozlamalar',
      sidebar: 'Yon navigatsiya',
      main: 'Asosiy navigatsiya',
      expand: 'Menyuni yoyish',
      collapse: 'Menyuni yigʻish',
    },
    packages: {
      title: 'Paketlar',
      detailTitle: 'Paket',
      detailNotFound: 'Paket topilmadi',
      loadError: 'Paketlarni yuklab boʻlmadi',
      listEmpty: 'Hozircha paket yoʻq',
      noParcels: 'Bu paketda sizning posilkangiz yoʻq',
      parcelsCount_one: '{{count}} ta posilka',
      parcelsCount_other: '{{count}} ta posilka',
      parcelsCount: '{{count}} ta posilka',
      notMineLabel: 'Boshqa mijoz posilkasi',
      batafsil: 'Batafsil',
      sections: {
        info: "Paket ma'lumotlari",
        parcels: 'Posilkalar ({{count}})',
      },
      fields: {
        name: 'Nomi',
        price: 'Narxi',
        weight: 'Ogʻirligi',
        createdAt: 'Yaratilgan sana',
      },
    },
    regions: {
      TASHKENT_CITY: 'Toshkent shahri',
      TASHKENT: 'Toshkent viloyati',
      FERGANA: 'Fargʻona',
      ANDIJAN: 'Andijon',
      NAMANGAN: 'Namangan',
      SAMARKAND: 'Samarqand',
      BUKHARA: 'Buxoro',
      SIRDARYA: 'Sirdaryo',
      SURKHANDARYA: 'Surxondaryo',
      NAVOI: 'Navoiy',
      QASHQADARYA: 'Qashqadaryo',
      KHOREZM: 'Xorazm',
      JIZZAKH: 'Jizzax',
      KARAKALPAKSTAN: 'Qoraqalpogʻiston',
      XIVA: 'Xiva',
    },
    parcelStatus: {
      DRAFT: 'Qoralama',
      PENDING: 'Moderatsiyada',
      APPROVED: 'Tasdiqlandi',
      REJECTED: 'Rad etildi',
      all: 'Barchasi',
    },
    fulfillment: {
      WAITING: 'Kutilmoqda',
      CONFIRMED: 'Yig\'ilyabdi',
      PACKAGED: 'Upakovlangan',
    },
    partyStatus: {
      COLLECTING: 'Qadoqlashda',
      SHIPPING: 'Joʻnatilmoqda',
      ON_THE_WAY: 'Yoʻlda',
      ON_CUSTOMS: 'Bojxonada',
      LOCAL_ON_THE_WAY: 'Omborga keldi',
      SHIPMENT_ON_CUSTOMERS: 'Topshirildi',
    },
    clientStatus: {
      IN_PROGRESS: 'Kutilmoqda',
      SORTING: 'Omborda',
      COLLECTING: 'Qadoqlashda',
      SHIPPING: 'Joʻnatilmoqda',
      ON_THE_WAY: 'Yoʻlda',
      ON_CUSTOMS: 'Bojxonada',
      LOCAL_ON_THE_WAY: 'Omborga keldi',
      SHIPMENT_ON_CUSTOMERS: 'Topshirildi',
    },
    parcels: {
      title: 'Posilkalarim',
      subtitle: 'Yangi posilka qoʻshing yoki kuzating',
      track: 'Kuzatish',
      searchPlaceholder: 'Trek ID yoki nom boʻyicha qidirish',
      loadError: 'Posilkalarni yuklab boʻlmadi',
      emptyFiltered: 'Filtr boʻyicha hech narsa topilmadi',
      emptyTitle: 'Hozircha posilka yoʻq',
      emptyDescription:
        'Birinchi posilkangizni yarating yoki PINFL va Trek ID orqali mavjud posilkani kuzatishga qoʻshing.',
      createParcel: 'Posilka yaratish',
      claimParcel: 'Kuzatishga qoʻshish',
      filterAll: 'Hammasi',
      filterByIdLabel: 'Cargo ID boʻyicha filtr',
      trek: 'Trek: {{trekId}}',
      limitRemaining: 'Qolgan limit',
      limitTotal: 'Umumiy limit',
      noLimitLegal: "Yuridik shaxs uchun cheklov yo'q",
      weight: '{{value}} kg',
      weightLabel: 'Ogʻirligi',
      surchargeLabel: 'Xizmat haqi',
      surchargeApplied: 'Xizmat haqi qoʻshilgan',
      splitLabel: "Bo'lingan posilka",
      deliveredToCustomer: 'Mijozga yetkazildi',
      confirmShipping: {
        select: 'Joʻnatishni tasdiqlash',
        action: 'Joʻnatishni tasdiqlash',
        selectedCount: '{{count}} ta tanlandi',
        confirmTitle: 'Joʻnatishni tasdiqlaysizmi?',
        confirmDescription:
          "Joʻnatishni tasdiqlasangiz, tanlangan posilkalar 'Yigʻilyabdi' holatiga oʻtadi. Bu amalni faqat admin bekor qila oladi. Davom etasizmi?",
        confirmAction: 'Joʻnatishni tasdiqlash',
        notInWarehouse:
          "Posilka omborga yetib kelganidan keyin jo'natishni tasdiqlash mumkin bo'ladi",
        toast: {
          success: '{{count}} ta posilka joʻnatishga tasdiqlandi',
          skipped: '{{count}} ta posilka oʻtkazib yuborildi',
        },
      },
      toast: {
        deleted: 'Posilka oʻchirildi',
      },
    },
    parcelDetail: {
      notFound: 'Posilka topilmadi',
      rejectReason: 'Rad etish sababi:',
      sections: {
        address: 'Manzil',
        recipient: 'Qabul qiluvchi',
        recipients: 'Qabul qiluvchilar',
        products: 'Mahsulotlar ({{count}})',
        party: 'Partiya',
      },
      partyName: 'Partiya nomi',
      partyStatusLabel: 'Partiya holati',
      address: {
        name: 'Manzil nomi',
        region: 'Viloyat',
        city: 'Shahar',
        street: 'Koʻcha',
        note: 'Izoh',
      },
      recipient: {
        fullName: 'Ism Sharif',
        phone: 'Telefon',
        passport: 'Pasport',
        pinfl: 'PINFL',
        limit: 'Limit',
      },
      charges: {
        title: 'Xizmatlar / Toʻlovlar',
        paid: 'Toʻlangan',
        unpaid: 'Toʻlanmagan',
        free: 'Bepul',
        totalPayable: 'Jami toʻlanadigan',
        types: {
          PACKAGE: 'Yetkazib berish',
          SPLIT: 'Posilkani boʻlish',
          PHOTO: 'Rasm yuborish',
          VIDEO: 'Video yuborish',
          PROVERKA: 'Mahsulotni tekshirish',
          RETURN: 'Posilkani qaytarish',
        },
      },
      pinflLimit: 'Limit: {{used}} / {{total}}',
      productsEmpty: 'Mahsulotlar qoʻshilmagan',
      declaration: 'Deklaratsiya',
      edit: 'Tahrirlash',
      delete: 'Oʻchirish',
      confirmDeleteTitle: 'Posilkani oʻchirasizmi?',
      confirmDeleteApproved:
        'Tasdiqlangan posilka roʻyxatdan olib tashlanadi, lekin admin uni koʻra oladi.',
      confirmDeleteDefault: 'Bu amalni qaytarib boʻlmaydi.',
      confirmDeleteAction: 'Ha, oʻchirish',
    },
    parcelForm: {
      titleCreate: 'Yangi posilka',
      titleEdit: 'Posilkani tahrirlash',
      subtitle: 'Maʼlumotlarni toʻldiring',
      cancel: 'Bekor qilish',
      save: 'Saqlash',
      saveAndContinue: 'Saqlash va davom etish',
      toast: {
        updated: 'Posilka yangilandi',
        savedDraft: 'Posilka qoralama sifatida saqlandi',
      },
      sectionBasic: 'Asosiy ma’lumotlar',
      sectionAddress: 'Qabul qiluvchi manzili',
      sectionPersonal: 'Qabul qiluvchi ma’lumotlari',
      pickRecipient: {
        title: 'Qabul qiluvchi tanlash',
        placeholder: 'Qabul qiluvchini tanlang',
        autoFillHint: 'Qabul qiluvchi ma’lumotlari avtomatik to‘ldiriladi',
        description: 'Saqlangan qabul qiluvchini tanlang — barcha maydonlar avtomatik toʻldiriladi.',
        action: 'Tanlash',
        dialogTitle: 'Qabul qiluvchini tanlang',
        searchPlaceholder: 'Ism yoki telefon boʻyicha qidirish',
        emptyTitle: 'Hozircha qabul qiluvchi yoʻq',
        emptyAction: 'Qabul qiluvchi qoʻshish',
        noMatches: 'Hech narsa topilmadi',
        appliedToast: 'Qabul qiluvchi maʼlumotlari yuklandi',
        noName: 'Nomsiz qabul qiluvchi',
        required: 'Davom etish uchun qabul qiluvchini tanlang',
      },
      fields: {
        name: 'Posilka nomi',
        namePlaceholder: 'iPhone 15 Pro',
        trekId: 'Trek ID',
        trekIdPlaceholder: 'ABC123456',
        storeName: 'Doʻkon nomi (ixtiyoriy)',
        storeNamePlaceholder: 'Amazon',
        addressName: 'Manzil nomi',
        addressNamePlaceholder: 'Uy, Ish, ...',
        region: 'Viloyat',
        city: 'Shahar',
        street: 'Koʻcha',
        building: 'Uy raqami',
        apartment: 'Xonadon (ixtiyoriy)',
        additionalInfo: 'Qoʻshimcha koʻrsatmalar',
        lastName: 'Familiya',
        firstName: 'Ism',
        middleName: 'Otasining ismi',
        phone: 'Telefon raqami',
        phonePlaceholder: '+998901234567',
        passport: 'Pasport seriya va raqami',
        passportPlaceholder: 'AA1234567',
        pinfl: 'PINFL',
        pinflPlaceholder: '{{length}} ta raqam',
      },
      pinfl: {
        checking: 'Limit tekshirilmoqda…',
        loadError: 'Limit olinmadi',
        remaining: 'Limit: {{used}} / {{total}}',
        noLimitLegal: "Yuridik shaxs uchun cheklov yo'q",
      },
      errors: {
        nameMin: 'Posilka nomi kamida 2 belgi',
        tooLong: 'Juda uzun',
        trekIdMin: 'Trek ID kamida 5 belgi',
        trekIdInvalid: 'Faqat lotin harflari, raqamlar va tire',
        addressNameRequired: 'Manzil nomi majburiy',
        regionRequired: 'Viloyatni tanlang',
        cityRequired: 'Shahar majburiy',
        streetRequired: 'Koʻcha majburiy',
        buildingRequired: 'Uy raqami majburiy',
        firstNameRequired: 'Ism majburiy',
        lastNameRequired: 'Familiya majburiy',
        middleNameRequired: 'Otasining ismi majburiy',
        phoneTooShort: 'Telefon raqami juda qisqa',
        phoneInvalid: 'Telefon raqami notoʻgʻri',
        passportRequired: 'Pasport seriyasi majburiy',
        passportInvalid: '2 katta lotin harfdan keyin 7 raqam, jami 9 belgi',
        pinflLength: 'PINFL {{length}} ta raqamdan iborat',
        pinflDigitsOnly: 'Faqat raqam',
      },
    },
    claim: {
      title: 'Posilkani kuzatish',
      subtitle: 'PINFL va Trek ID kiriting',
      sectionTitle: 'Kuzatishga qoʻshish',
      sectionDescription:
        'Boshqa foydalanuvchi yaratgan posilkani PINFL va Trek ID orqali kuzatib boring.',
      pinfl: 'PINFL',
      pinflPlaceholder: '{{length}} ta raqam',
      trekId: 'Trek ID',
      trekIdPlaceholder: 'ABC123456',
      submit: 'Qoʻshish',
      toast: {
        added: 'Posilka kuzatishga qoʻshildi',
      },
      errors: {
        pinflLength: 'PINFL {{length}} ta raqamdan iborat',
        pinflDigitsOnly: 'Faqat raqam',
        trekIdMin: 'Trek ID kamida 5 belgi',
        tooLong: 'Juda uzun',
        trekIdInvalid: 'Faqat lotin, raqam, tire',
      },
    },
    cargoId: {
      title: 'Cargo ID',
      loadError: 'Cargo IDni yuklab boʻlmadi',
      requestAction: 'Cargo ID olish',
      connectAction: "Cargo ID'ga ulanish",
      emptyTitle: 'Hozircha Cargo ID yoʻq',
      emptyDescription: 'Cargo ID oling — shundan keyin posilkalaringizni yaratishingiz mumkin boʻladi.',
      profileBanner: {
        label: 'Cargo ID',
        helper: 'Siz posilka yaratishingiz mumkin',
        noneTitle: 'Cargo ID hali yoʻq',
        noneHelper: 'Cargo ID oling — shundan keyin posilkalaringizni yaratishingiz mumkin boʻladi.',
        getCta: 'Cargo ID olish',
        connectCta: "Cargo ID'ga ulanish",
        copy: 'Nusxalash',
        copied: 'Cargo ID nusxalandi',
        copyFailed: 'Nusxalab boʻlmadi',
      },
      debt: {
        label: 'Qarzdorlik',
        none: 'Qarzdorlik yoʻq',
        title: 'Qarzdorlik',
        total: 'Jami qarz',
        loadError: 'Qarzdorlikni yuklab boʻlmadi',
        emptyHelper: 'Barcha xizmatlar uchun toʻlov qilingan.',
        otherServices: 'Boshqa xizmatlar',
        packageLine: 'Paket {{name}} · {{date}}',
        openParcelHint: 'Batafsil koʻrish uchun posilka ustiga bosing.',
      },
      parcelGate: {
        label: 'Cargo ID kerak',
        dialogTitle: 'Cargo ID kerak',
        dialogDescription:
          "Posilka yaratish uchun avval Cargo ID olishingiz kerak.",
        noneTitle: 'Cargo ID hali yoʻq',
        noneHelper: "Posilka yaratish uchun avval Cargo ID olishingiz kerak — u darhol beriladi.",
        getCta: 'Cargo ID olish',
        cancel: 'Bekor qilish',
      },
      entityType: {
        PHYSICAL: 'Jismoniy',
        LEGAL: 'Yuridik',
      },
      actions: {
        unbind: 'Akkauntdan uzish',
      },
      fields: {
        fullName: 'Toʻliq ism',
        phone: 'Telefon raqami',
        phonePlaceholder: '+998901234567',
      },
      request: {
        title: 'Cargo ID olish',
        subtitle: 'Maʼlumotlarni toʻldiring',
        submit: 'Cargo ID olish',
        typeLabel: 'Shaxs turi',
      },
      connect: {
        title: "Cargo ID'ga ulanish",
        submit: 'Ulanish',
        fields: {
          code: 'CID-12345',
          codeLabel: 'Cargo ID kodi',
        },
        toast: {
          connected: 'Ulandi',
        },
        errors: {
          notFound: 'Cargo ID topilmadi',
        },
      },
      confirmUnbindTitle: 'Cargo IDni akkauntdan uzasizmi?',
      confirmUnbindDescription: "Cargo ID akkauntingizdan uziladi, lekin tizimda saqlanib qoladi va keyinroq yana ulanishingiz mumkin.",
      toast: {
        issued: 'Cargo ID berildi: {{code}}',
        deleted: 'Cargo ID akkauntdan uzildi',
      },
      errors: {
        fullNameRequired: 'Toʻliq ism majburiy',
        phoneRequired: 'Telefon raqami majburiy',
        codeRequired: 'Cargo ID kodi majburiy',
        tooLong: 'Juda uzun',
      },
    },
    declaration: {
      title: 'Deklaratsiya',
      addProduct: 'Mahsulot qoʻshish',
      save: 'Saqlash',
      submit: 'Tasdiqlashga yuborish',
      confirmTitle: 'Tasdiqlashga yuborilsinmi?',
      confirmDescription:
        'Posilkani moderatsiyaga yuborganingizdan keyin uni tahrirlay olmaysiz.',
      confirmAction: 'Ha, yuborish',
      loadCategoriesError: 'Kategoriyalar yuklanmadi',
      product: 'Mahsulot #{{index}}',
      remove: 'Oʻchirish',
      category: 'Kategoriya',
      categoryPlaceholder: 'Tanlang',
      subcategory: 'Subkategoriya',
      subcategoryPlaceholder: 'Tanlang',
      subcategoryPlaceholderDisabled: 'Avval kategoriya tanlang',
      fullName: 'Toʻliq nomi',
      fullNamePlaceholder: 'iPhone 15 Pro 256GB',
      quantity: 'Miqdori',
      unitPrice: '1 ta narxi (USD)',
      limitLoading: 'PINFL limit yuklanmoqda…',
      limitNotFound: 'PINFL limiti topilmadi',
      limitTitle: 'Limit:',
      noLimitLegal: "Yuridik shaxs uchun cheklov yo'q",
      used: 'Ishlatilgan: {{amount}}',
      now: 'Hozir: {{amount}}',
      notEnough: 'Limitdan oshdi',
      remaining: 'Qolgan: {{amount}}',
      overLimit: 'Limitdan {{amount}} ga oshib ketgan',
      resetHint: 'Limit {{date}} da yangilanadi',
      validation: {
        atLeastOne: 'Kamida 1 ta mahsulot kerak',
        productPrefix: 'Mahsulot #{{index}}: {{message}}',
        check: 'tekshiring',
        incomplete: 'Forma toʻliq emas',
        // Advisory only — exceeding the PINFL limit no longer blocks submission.
        limitNotEnough: 'Limitdan oshib ketdi',
      },
      toast: {
        saved: 'Mahsulotlar saqlandi',
        submitted: 'Posilka tasdiqlashga yuborildi',
      },
      errors: {
        categorySelect: 'Kategoriya tanlang',
        categoryRequired: 'Kategoriya majburiy',
        subcategorySelect: 'Subkategoriya tanlang',
        subcategoryRequired: 'Subkategoriya majburiy',
        fullNameRequired: 'Mahsulot nomi majburiy',
        tooLong: 'Juda uzun',
        quantityInt: 'Faqat butun son',
        quantityMin: 'Kamida 1 dona',
        priceMin: 'Narxini kiriting',
        priceMax: 'Juda katta',
        priceDecimals: 'Koʻpi bilan 2 ta kasr raqam',
      },
    },
    profile: {
      title: 'Profil',
      loadError: 'Profil maʼlumotlari yuklanmadi',
      debts: {
        title: 'Yetib kelgan qarzlar',
        total: 'Jami qarz',
        error: 'Qarzlarni yuklab boʻlmadi',
      },
      receipts: {
        title: 'Toʻlov cheklari',
        number: 'Chek №{{number}}',
        download: 'Yuklab olish',
        error: 'Cheklarni yuklab boʻlmadi',
      },
      changePhoto: 'Rasmni oʻzgartirish',
      addLanguage: 'Qoʻshish',
      removeLanguage: '{{language}} ni oʻchirish',
      languagesPlaceholder: 'Tilni kiriting',
      fields: {
        email: 'Email',
        firstName: 'Ism',
        lastName: 'Familiya',
        phone: 'Telefon raqami',
        languages: 'Suhbatlasha oladigan tillar',
      },
      toast: {
        saved: 'Profil yangilandi',
        avatarUpdated: 'Rasm yangilandi',
      },
      errors: {
        tooLong: 'Juda uzun',
        avatarType: 'Faqat JPG, PNG yoki WEBP rasm',
        avatarSize: 'Rasm hajmi 5MB dan oshmasligi kerak',
      },
      deleteAccount: {
        button: 'Akkauntni oʻchirish',
        modal: {
          title: 'Akkauntni oʻchirasizmi?',
          description: 'Bu amal qaytarilmaydi. Shaxsiy maʼlumotlaringiz (ism, email, Google bogʻlanishi, telefon, bildirishnomalar, manzillar, support yozishmalari) oʻchiriladi. Posilka va toʻlov tarixi qonuniy talablar uchun anonim holatda saqlanadi.',
          confirm: 'Ha, oʻchirish',
          cancel: 'Bekor qilish',
        },
        toast: {
          success: 'Akkauntingiz oʻchirildi',
          error: 'Akkauntni oʻchirib boʻlmadi',
        },
      },
    },
    settings: {
      title: 'Sozlamalar',
      account: 'Hisob',
      accountEmpty: 'Foydalanuvchi maʼlumotlari mavjud emas.',
      appInfo: 'Ilova haqida',
      appSubtitle: 'Mijoz ilovasi',
      languageTitle: 'Til',
      languageDescription: 'Ilova tilini tanlang',
      rows: {
        addresses: 'Mening qabul qiluvchilarim',
        onlineAddress: 'Onlayn xarid qilish uchun manzil',
        wikishop: 'Tez Japan Cargo Store',
        telegramBot: 'Telegram botga obuna boʻlish',
        telegramChannel: 'Telegram kanalga obuna boʻlish',
        support: 'Yordam',
        supportStaff: 'Texnik yordamchilar',
        language: 'Til',
        comingSoon: 'Tez kunda',
      },
    },
    services: {
      sectionTitle: 'Xizmatlar',
      additionalServices: 'Qoʻshimcha xizmatlar',
      techHelper: 'Sotib olishga yordam',
      sendPhoto: 'Rasm yuborish',
      sendVideo: 'Video yuborish',
      proverkaService: 'Mahsulotni tekshirish',
      returnService: 'Posilkani qaytarish',
      splitParcel: 'Posilkani boʻlish',
      selectParcel: 'Posilkani tanlang',
      noParcelsAvailable: 'Mavjud posilkalar yoʻq',
      contactInfo: 'Bogʻlanish maʼlumoti',
      contactInfoHint: 'Telegram username yoki havola',
      contactInfoRequired: 'Bogʻlanish maʼlumotini kiriting',
      note: 'Izoh',
      noteOptional: 'Izoh (ixtiyoriy)',
      photoFee: 'Rasm narxi',
      videoFee: 'Video narxi',
      proverkaFee: 'Tekshirish narxi',
      submit: 'Yuborish',
      reportCreated: 'Soʻrov yuborildi',
      reportError: 'Soʻrovni yuborishda xatolik',
      reportDuplicate: "Bu posilka uchun bunday soʻrov allaqachon yuborilgan",
      reportNotOwned: 'Posilka topilmadi yoki sizga tegishli emas',
      photoTitle: 'Rasm yuborish',
      videoTitle: 'Video yuborish',
      proverkaTitle: 'Mahsulotni tekshirish',
      returnTitle: 'Posilkani qaytarish',
      returnReason: 'Sababi (ixtiyoriy)',
      returnFeeLabel: 'Vozvrat narxi',
      returnCreated: "Vozvrat so'rovi yuborildi",
      returnError: 'Soʻrovni yuborishda xatolik',
    },
    onlineAddress: {
      title: 'Onlayn xarid qilish uchun manzil',
      intro: 'AQSh onlayn doʻkonlaridan xarid qilganda quyidagi manzilni koʻrsating.',
      copy: 'Nusxalash',
      copied: 'Nusxalandi',
      copyFailed: 'Nusxalab boʻlmadi',
      fields: {
        fullName: 'Fullname (ism)',
        addressLine1: 'Address line 1 (manzilning birinchi qatori)',
        addressLine2: 'Address line 2 (sizning kodingiz)',
        city: 'City (shahar)',
        state: 'State (shtat)',
        zipcode: 'Zipcode (indeks)',
        telephone: 'Telephone (telefon raqam)',
      },
      warning:
        "E'tibor bering! Manzilda STE 3 koʻrsatilishi zarur, ushbu belgilarsiz posilka boshqa manzilga yetkazilishi mumkin. Agar STE 3 «Address line 1» da qabul qilinmasa, uni «Address line 2»ga kiritish kerak.",
    },
    addresses: {
      title: 'Mening qabul qiluvchilarim',
      add: 'Qoʻshish',
      edit: 'Tahrirlash',
      delete: 'Oʻchirish',
      defaultBadge: 'Asosiy',
      emptyTitle: 'Hozircha qabul qiluvchilar yoʻq',
      emptyDescription: 'Tez toʻldirish uchun yetkazib berish manzilingizni saqlab qoʻying.',
      confirmDeleteTitle: 'Manzilni oʻchirasizmi?',
      confirmDeleteDescription: 'Bu amalni qaytarib boʻlmaydi.',
      confirmDeleteAction: 'Ha, oʻchirish',
      sectionAddress: 'Qabul qiluvchi manzili',
      sectionPersonal: 'Qabul qiluvchi maʼlumotlari',
      pageTitle: {
        create: 'Manzil qoʻshish',
        edit: 'Manzilni tahrirlash',
      },
      form: {
        addTitle: 'Yangi manzil',
        editTitle: 'Manzilni tahrirlash',
        label: 'Nomi',
        labelPlaceholder: 'Uy, Ish, ...',
        labelHelp:
          'Manzilga oʻzingiz uchun qisqa nom bering, masalan "Uy", "Ish" yoki "Ota-onamniki". Bu saqlangan manzillarni bir-biridan ajratish uchun. Bu haqiqiy koʻcha manzili emas.',
        addressName: 'Manzil nomi',
        addressNamePlaceholder: 'Qabul qiluvchi manzili',
        addressNameHelp:
          'Qabul qiluvchining toʻliq, haqiqiy manzilini kiriting — posilka aynan shu joyga yetkaziladi.',
        region: 'Viloyat',
        city: 'Shahar',
        street: 'Koʻcha',
        building: 'Uy raqami',
        apartment: 'Xonadon (ixtiyoriy)',
        additionalInfo: 'Qoʻshimcha koʻrsatmalar',
        isDefault: 'Asosiy manzil sifatida belgilash',
      },
      toast: {
        created: 'Manzil qoʻshildi',
        updated: 'Manzil yangilandi',
        deleted: 'Manzil oʻchirildi',
      },
      errors: {
        labelRequired: 'Nomi majburiy',
        addressNameRequired: 'Manzil nomi majburiy',
        regionRequired: 'Viloyatni tanlang',
        cityRequired: 'Shahar majburiy',
        streetRequired: 'Koʻcha majburiy',
        buildingRequired: 'Uy raqami majburiy',
        firstNameRequired: 'Ism majburiy',
        lastNameRequired: 'Familiya majburiy',
        middleNameRequired: 'Otasining ismi majburiy',
        phoneTooShort: 'Telefon raqami juda qisqa',
        phoneInvalid: 'Telefon raqami notoʻgʻri',
        passportRequired: 'Pasport seriyasi majburiy',
        passportInvalid: '2 katta lotin harfdan keyin 7 raqam, jami 9 belgi',
        pinflLength: 'PINFL {{length}} ta raqamdan iborat',
        pinflDigitsOnly: 'Faqat raqam',
        tooLong: 'Juda uzun',
      },
    },
    splits: {
      title: 'Posilkani boʻlish',
      start: 'Posilkani boʻlish',
      subtitle: 'Qabul qiluvchilarni qoʻshing',
      trek: 'Trek: {{trekId}}',
      loadError: 'Boʻlinmani yuklab boʻlmadi',
      notFound: 'Boʻlinma topilmadi',
      parcelTotal: 'Posilka qiymati',
      serviceFee: 'Xizmat haqi',
      createdAt: 'Yaratilgan sana',
      statusLabel: 'Holat',
      status: {
        DRAFT: 'Qoralama',
        IN_PROGRESS: 'Jarayonda',
        DELIVERED: 'Yetkazildi',
      },
      sectionTargets: 'Qabul qiluvchilar',
      sectionTargetsCount: '{{count}} ta qabul qiluvchi',
      targetTitle: '{{index}}-qabul qiluvchi',
      addTarget: 'Qabul qiluvchi qoʻshish',
      removeTarget: 'Oʻchirish',
      sectionAddress: 'Qabul qiluvchi manzili',
      sectionPersonal: 'Qabul qiluvchi maʼlumotlari',
      save: 'Saqlash',
      saveTargets: 'Saqlash',
      reservedAmount: 'Band qilingan',
      totalAmount: 'Jami',
      targetsEmpty: 'Hozircha qabul qiluvchi yoʻq',
      limit: 'Limit',
      sectionProducts: 'Mahsulotlar',
      detailsShow: 'Batafsil',
      detailsHide: 'Yopish',
      packageInfo: 'Paket maʼlumotlari',
      allocatedProducts: 'Ajratilgan mahsulotlar',
      editableHint: 'Faqat qoralama holatida tahrirlash mumkin',
      pickRecipient: {
        title: 'Mening qabul qiluvchilarim',
        placeholder: 'Saqlangan qabul qiluvchidan tanlang',
        autoFillHint: 'Qabul qiluvchi maʼlumotlari avtomatik toʻldiriladi',
        noName: 'Nomsiz qabul qiluvchi',
      },
      toast: {
        created: 'Boʻlinma yaratildi',
        targetsSaved: 'Qabul qiluvchilar saqlandi',
      },
      fields: {
        pinfl: 'PINFL',
        pinflPlaceholder: '{{length}} ta raqam',
        lastName: 'Familiya',
        firstName: 'Ism',
        middleName: 'Otasining ismi',
        phone: 'Telefon raqami',
        phonePlaceholder: '+998901234567',
        passport: 'Pasport seriya va raqami',
        passportPlaceholder: 'AA1234567',
        addressName: 'Manzil nomi',
        region: 'Viloyat',
        city: 'Shahar',
        street: 'Koʻcha',
        building: 'Uy raqami',
        apartment: 'Xonadon (ixtiyoriy)',
        additionalInfo: 'Qoʻshimcha koʻrsatmalar',
        packageName: 'Paket nomi',
        packageNamePlaceholder: 'Nom generatsiya qiling',
        packageWeight: 'Vazni',
        packageWeightUnit: 'Birlik',
        packagePrice: 'Paket narxi',
      },
      package: {
        generateName: 'Nom generatsiya',
        downloadQr: 'QR yuklab olish',
      },
      distribution: {
        title: 'Mahsulot taqsimoti',
        noProducts: 'Mahsulotlar yoʻq',
        available: 'jami × {{count}}',
        error: 'Har bir mahsulot toʻliq va aniq taqsimlanishi kerak:',
        mismatchLine: '{{name}}: taqsimlangan {{allocated}} / {{expected}}',
      },
      errors: {
        pinflLength: 'PINFL {{length}} ta raqamdan iborat',
        pinflDigitsOnly: 'Faqat raqam',
        pinflDuplicate: 'Bu PINFL boshqa qabul qiluvchida ishlatilgan',
        firstNameRequired: 'Ism majburiy',
        lastNameRequired: 'Familiya majburiy',
        middleNameRequired: 'Otasining ismi majburiy',
        phoneTooShort: 'Telefon raqami juda qisqa',
        phoneInvalid: 'Telefon raqami notoʻgʻri',
        passportRequired: 'Pasport seriyasi majburiy',
        passportInvalid: '2 katta lotin harfdan keyin 7 raqam, jami 9 belgi',
        addressNameRequired: 'Manzil nomi majburiy',
        regionRequired: 'Viloyatni tanlang',
        cityRequired: 'Shahar majburiy',
        streetRequired: 'Koʻcha majburiy',
        buildingRequired: 'Uy raqami majburiy',
        packageNameRequired: 'Paket nomini generatsiya qiling',
        weightRequired: 'Vazni majburiy',
        weightInvalid: 'Vazn 0 dan katta boʻlsin',
        weightUnitRequired: 'Birlikni tanlang',
        quantityInvalid: 'Notoʻgʻri miqdor',
        tooLong: 'Juda uzun',
        targetsMin: 'Kamida bitta qabul qiluvchi qoʻshing',
      },
    },
    login: {
      tagline: 'Yaponiyadan Oʻzbekistonga posilkalarni boshqaring',
      signIn: 'Tizimga kirish',
      googlePrompt: 'Davom etish uchun Google hisobingiz bilan kiring.',
      terms: 'Kirish orqali xizmat shartlariga rozilik bildirasiz.',
      devTitle: 'Dev: tokenlar bilan kirish',
      devAccessLabel: 'Access token',
      devRefreshLabel: 'Refresh token',
      devSubmit: 'Saqlash va kirish',
      googleSignIn: 'Google bilan kirish',
      apple: 'Apple bilan kirish',
      signingIn: 'Tizimga kirilmoqda',
      bridgeNoResponse: 'Koʻprik javob bermadi',
      googleCancelled: 'Google kirish bekor qilindi',
      googleNotConfigured: 'Google Client ID sozlanmagan',
      googleConfigHint:
        '.env faylida VITE_GOOGLE_CLIENT_ID qiymatini kiriting yoki Flutter koʻprigi orqali kiring.',
    },
    support: {
      title: 'Yordam',
      faqTitle: 'Koʻp soʻraladigan savollar',
      faqEmpty: 'Hozircha savollar yoʻq',
      contact: 'Bogʻlanish',
      contactHint: 'Savolingiz boʻlsa, administrator bilan yozishing',
      chatTitle: 'Administrator bilan chat',
      chatLoadError: 'Chatni yuklab boʻlmadi',
      chatEmpty: 'Hozircha xabarlar yoʻq. Birinchi xabaringizni yozing.',
      placeholder: 'Xabar yozing…',
      send: 'Yuborish',
      attach: 'Fayl biriktirish',
      removeAttachment: 'Faylni olib tashlash',
      imageAlt: 'Biriktirilgan rasm',
      download: 'Yuklab olish',
      blocked: 'Siz bloklangansiz — habaringiz yuborilmadi',
      blockedBanner: 'Siz bloklangansiz. Xabar yubora olmaysiz.',
      fileTooLarge: 'Fayl hajmi 5MB dan oshmasligi kerak',
      sendError: 'Xabar yuborilmadi',
    },
    supportStaff: {
      title: 'Texnik yordamchilar',
      contact: 'Bogʻlanish',
      experience: 'Ish staji: {{years}} yil',
      languages: 'Tillar',
      emptyTitle: 'Hozircha yordamchilar yoʻq',
      emptyDescription: 'Texnik yordamchilar tez orada qoʻshiladi.',
      error: 'Maʼlumotlarni yuklashda xatolik',
    },
    notifications: {
      title: 'Bildirishnomalar',
      emptyTitle: 'Hozircha bildirishnoma yoʻq',
      emptyDescription: 'Yangi xabarlar shu yerda paydo boʻladi.',
      markAllRead: 'Hammasini oʻqilgan deb belgilash',
      loadMore: 'Yana koʻrsatish',
      unread: 'Yangi',
      imageAlt: 'Bildirishnoma rasmi',
      timeAgo: '{{value}} oldin',
      justNow: 'hozirgina',
      announcementTitle: "E'lon",
      close: 'Yopish',
      viewReceipt: "Chekni ko'rish",
    },
    notFound: {
      title: 'Sahifa topilmadi',
      description: 'Siz qidirayotgan sahifa mavjud emas yoki olib tashlangan.',
      goHome: 'Bosh sahifaga',
    },
    tracking: {
      title: 'Kuzatish',
      inputLabel: 'Trek ID',
      inputPlaceholder: 'ABC123456',
      submit: 'Tekshirish',
      submitSave: 'Saqlash',
      resultLabel: 'Trek ID',
      loadError: "Holatni tekshirib bo'lmadi",
      save: 'Saqlash',
      unsave: 'Saqlashdan olib tashlash',
      savedBadge: 'Saqlangan',
      savedListTitle: "Saqlangan trek ID'lar",
      savedEmpty: 'Hozircha saqlanmagan',
      removeSaved: "Ro'yxatdan olib tashlash",
      confirmRemoveTitle: "Trek ID'ni saqlashdan olib tashlaysizmi?",
      confirmRemoveDescription: "{{trekId}} saqlangan ro'yxatdan olib tashlanadi.",
      errors: {
        invalidFormat: 'Faqat harf va raqam (5–255 belgi)',
      },
      state: {
        not_found: 'Mavjud emas',
        waiting: 'Kutilyabdi',
        collecting: "Yig'ilyabdi",
        in_party: 'Posilkada',
      },
      hint: {
        not_found: 'Bu trek ID omborga kelmagan.',
        waiting: 'Omborga keldi, lekin egasi posilka yaratmagan.',
        collecting: "Mijoz jo'natishni tasdiqlagan.",
        in_party: 'Posilka guruhda.',
      },
      toast: {
        saved: 'Trek ID saqlandi',
        removed: "Trek ID ro'yxatdan olib tashlandi",
      },
    },
    receipt: {
      paid: "To'landi",
      brandTagline: 'Yaponiyadan Oʻzbekistonga ishonchli yetkazib berish',
      receiptNumber: 'Chek raqami',
      date: 'Sana',
      customer: 'Mijoz',
      cargoId: 'Cargo ID',
      parcel: 'Posilka',
      trekId: 'Trek ID',
      service: 'Xizmat',
      downloadPdf: 'PDF yuklab olish',
      back: 'Ortga',
      footer: "Rasmiy to'lov cheki · Tez Cargo",
      notFoundTitle: 'Chek topilmadi',
      notFoundDescription: "Bunday to'lov cheki mavjud emas yoki havola noto'g'ri.",
      loadError: 'Chekni yuklab boʻlmadi',
      retry: 'Qayta urinish',
    },
    payments: {
      title: "To'lov tarixi",
      subtitle: "Barcha to'lov cheklaringiz",
      view: "Ko'rish",
      pdf: 'PDF',
      number: 'Chek №{{number}}',
      emptyTitle: "To'lovlar yo'q",
      emptyDescription: "To'lovlaringiz shu yerda ko'rinadi.",
      viewAll: "Barchasini ko'rish",
      loadError: 'Cheklarni yuklab boʻlmadi',
      retry: 'Qayta urinish',
    },
  },
  ru: {
    common: {
      language: 'Язык',
      uzbek: 'Oʻzbekcha',
      russian: 'Русский',
      english: 'English',
      kazakh: 'Қазақша',
      cancel: 'Отмена',
      save: 'Сохранить',
      confirm: 'Подтвердить',
      back: 'Назад',
      next: 'Следующая',
      delete: 'Удалить',
      retry: 'Повторить',
      loading: 'Загрузка',
      help: 'Справка',
      errorGeneric: 'Произошла ошибка',
      total: 'Итого',
      logout: 'Выход',
      loggedOut: 'Вы вышли из системы',
      loginSuccess: 'Вы успешно вошли в систему',
      loginError: 'Ошибка входа в систему',
      flutterBridgeMissing: 'Мост Flutter недоступен',
      tokensSaved: 'Токены сохранены',
      errorBoundary: {
        title: 'Произошла ошибка',
        description: 'Пожалуйста, повторите попытку. Если проблема сохраняется, вернитесь на главную страницу.',
        retry: 'Повторить',
        goHome: 'На главную страницу',
      },
    },
    nav: {
      parcels: 'Посылки',
      parcelsShort: 'Посылки',
      packages: 'Пакеты',
      create: 'Новая посылка',
      createShort: 'Создать',
      claim: 'Добавить в отслеживание',
      claimShort: 'Поиск',
      track: 'Отслеживание',
      ids: 'Cargo ID',
      support: 'Поддержка',
      settings: 'Настройки',
      sidebar: 'Боковая навигация',
      main: 'Основная навигация',
      expand: 'Развернуть меню',
      collapse: 'Свернуть меню',
    },
    packages: {
      title: 'Пакеты',
      detailTitle: 'Пакет',
      detailNotFound: 'Пакет не найден',
      loadError: 'Не удалось загрузить пакеты',
      listEmpty: 'Пакетов пока нет',
      noParcels: 'В этом пакете нет ваших посылок',
      parcelsCount_one: '{{count}} посылка',
      parcelsCount_few: '{{count}} посылки',
      parcelsCount_many: '{{count}} посылок',
      parcelsCount_other: '{{count}} посылок',
      parcelsCount: '{{count}} посылок',
      notMineLabel: 'Посылка другого клиента',
      batafsil: 'Подробнее',
      sections: {
        info: 'Информация о пакете',
        parcels: 'Посылки ({{count}})',
      },
      fields: {
        name: 'Название',
        price: 'Цена',
        weight: 'Вес',
        createdAt: 'Дата создания',
      },
    },
    regions: {
      TASHKENT_CITY: 'Город Ташкент',
      TASHKENT: 'Ташкентская область',
      FERGANA: 'Фергана',
      ANDIJAN: 'Андижан',
      NAMANGAN: 'Наманган',
      SAMARKAND: 'Самарканд',
      BUKHARA: 'Бухара',
      SIRDARYA: 'Сырдарья',
      SURKHANDARYA: 'Сурхандарья',
      NAVOI: 'Навои',
      QASHQADARYA: 'Кашкадарья',
      KHOREZM: 'Хорезм',
      JIZZAKH: 'Джизак',
      KARAKALPAKSTAN: 'Каракалпакстан',
      XIVA: 'Хива',
    },
    parcelStatus: {
      DRAFT: 'Черновик',
      PENDING: 'На модерации',
      APPROVED: 'Одобрена',
      REJECTED: 'Отклонена',
      all: 'Все',
    },
    fulfillment: {
      WAITING: 'Ожидает',
      CONFIRMED: 'Собирается',
      PACKAGED: 'Упакована',
    },
    partyStatus: {
      COLLECTING: 'отправить в упаковку',
      SHIPPING: 'в процессе отправки',
      ON_THE_WAY: 'В пути',
      ON_CUSTOMS: 'на таможне',
      LOCAL_ON_THE_WAY: 'поступило на склад',
      SHIPMENT_ON_CUSTOMERS: 'Выдано получателю',
    },
    clientStatus: {
      IN_PROGRESS: 'Ожидаемые',
      SORTING: 'На складе',
      COLLECTING: 'отправить в упаковку',
      SHIPPING: 'в процессе отправки',
      ON_THE_WAY: 'В пути',
      ON_CUSTOMS: 'на таможне',
      LOCAL_ON_THE_WAY: 'поступило на склад',
      SHIPMENT_ON_CUSTOMERS: 'Выдано получателю',
    },
    parcels: {
      title: 'Мои посылки',
      subtitle: 'Добавьте новую посылку или отслеживайте',
      track: 'Отслеживание',
      searchPlaceholder: 'Поиск по Trek ID или названию',
      loadError: 'Не удалось загрузить посылки',
      emptyFiltered: 'По фильтру ничего не найдено',
      emptyTitle: 'Посылок пока нет',
      emptyDescription:
        'Создайте первую посылку или добавьте существующую в отслеживание по PINFL и Trek ID.',
      createParcel: 'Создать посылку',
      claimParcel: 'Добавить в отслеживание',
      filterAll: 'Все',
      filterByIdLabel: 'Фильтр по Cargo ID',
      trek: 'Trek: {{trekId}}',
      limitRemaining: 'Остаток лимита',
      limitTotal: 'Общий лимит',
      noLimitLegal: 'Для юридического лица лимит не действует',
      weight: '{{value}} кг',
      weightLabel: 'Вес',
      surchargeLabel: 'Сервисный сбор',
      surchargeApplied: 'Добавлен сервисный сбор',
      splitLabel: 'Разделённая посылка',
      deliveredToCustomer: 'Доставлено клиенту',
      confirmShipping: {
        select: 'Подтвердить отправку',
        action: 'Подтвердить отправку',
        selectedCount: 'Выбрано: {{count}}',
        confirmTitle: 'Подтвердить отправку?',
        confirmDescription:
          'Если подтвердить отправку, выбранные посылки перейдут в статус «Собирается». Это действие может отменить только администратор. Продолжить?',
        confirmAction: 'Подтвердить отправку',
        notInWarehouse:
          'Подтвердить отправку можно будет после того, как посылка поступит на склад',
        toast: {
          success: '{{count}} посылок подтверждено к отправке',
          skipped: 'Пропущено посылок: {{count}}',
        },
      },
      toast: {
        deleted: 'Посылка удалена',
      },
    },
    parcelDetail: {
      notFound: 'Посылка не найдена',
      rejectReason: 'Причина отклонения:',
      sections: {
        address: 'Адрес',
        recipient: 'Получатель',
        recipients: 'Получатели',
        products: 'Товары ({{count}})',
        party: 'Партия',
      },
      partyName: 'Название партии',
      partyStatusLabel: 'Статус партии',
      address: {
        name: 'Название адреса',
        region: 'Регион',
        city: 'Город',
        street: 'Улица',
        note: 'Примечание',
      },
      recipient: {
        fullName: 'ФИО',
        phone: 'Телефон',
        passport: 'Паспорт',
        pinfl: 'PINFL',
        limit: 'Лимит',
      },
      charges: {
        title: 'Услуги / Платежи',
        paid: 'Оплачено',
        unpaid: 'Не оплачено',
        free: 'Бесплатно',
        totalPayable: 'Итого к оплате',
        types: {
          PACKAGE: 'Доставка',
          SPLIT: 'Разделение посылки',
          PHOTO: 'Отправка фото',
          VIDEO: 'Отправка видео',
          PROVERKA: 'Проверка товара',
          RETURN: 'Возврат посылки',
        },
      },
      pinflLimit: 'Лимит: {{used}} / {{total}}',
      productsEmpty: 'Товары не добавлены',
      declaration: 'Декларация',
      edit: 'Редактировать',
      delete: 'Удалить',
      confirmDeleteTitle: 'Удалить посылку?',
      confirmDeleteApproved:
        'Одобренная посылка будет убрана из списка, но администратор сможет её видеть.',
      confirmDeleteDefault: 'Это действие нельзя отменить.',
      confirmDeleteAction: 'Да, удалить',
    },
    parcelForm: {
      titleCreate: 'Новая посылка',
      titleEdit: 'Редактировать посылку',
      subtitle: 'Заполните данные',
      cancel: 'Отмена',
      save: 'Сохранить',
      saveAndContinue: 'Сохранить и продолжить',
      toast: {
        updated: 'Посылка обновлена',
        savedDraft: 'Посылка сохранена как черновик',
      },
      sectionBasic: 'Основные данные',
      sectionAddress: 'Адрес получателя',
      sectionPersonal: 'Данные получателя',
      pickRecipient: {
        title: 'Выбрать получателя',
        placeholder: 'Выберите получателя',
        autoFillHint: 'Данные получателя заполнятся автоматически',
        description: 'Выберите сохранённого получателя — все поля заполнятся автоматически.',
        action: 'Выбрать',
        dialogTitle: 'Выберите получателя',
        searchPlaceholder: 'Поиск по имени или телефону',
        emptyTitle: 'Получателей пока нет',
        emptyAction: 'Добавить получателя',
        noMatches: 'Ничего не найдено',
        appliedToast: 'Данные получателя загружены',
        noName: 'Без имени',
        required: 'Выберите получателя, чтобы продолжить',
      },
      fields: {
        name: 'Название посылки',
        namePlaceholder: 'iPhone 15 Pro',
        trekId: 'Trek ID',
        trekIdPlaceholder: 'ABC123456',
        storeName: 'Название магазина (необязательно)',
        storeNamePlaceholder: 'Amazon',
        addressName: 'Название адреса',
        addressNamePlaceholder: 'Дом, Работа, ...',
        region: 'Регион',
        city: 'Город',
        street: 'Улица',
        building: 'Номер дома',
        apartment: 'Квартира (необязательно)',
        additionalInfo: 'Дополнительные указания',
        lastName: 'Фамилия',
        firstName: 'Имя',
        middleName: 'Отчество',
        phone: 'Номер телефона',
        phonePlaceholder: '+998901234567',
        passport: 'Серия и номер паспорта',
        passportPlaceholder: 'AA1234567',
        pinfl: 'PINFL',
        pinflPlaceholder: '{{length}} цифр',
      },
      pinfl: {
        checking: 'Проверка лимита…',
        loadError: 'Не удалось получить лимит',
        remaining: 'Лимит: {{used}} / {{total}}',
        noLimitLegal: 'Для юридического лица лимит не действует',
      },
      errors: {
        nameMin: 'Название минимум 2 символа',
        tooLong: 'Слишком длинно',
        trekIdMin: 'Trek ID минимум 5 символов',
        trekIdInvalid: 'Только латиница, цифры и дефис',
        addressNameRequired: 'Название адреса обязательно',
        regionRequired: 'Выберите регион',
        cityRequired: 'Город обязателен',
        streetRequired: 'Улица обязательна',
        buildingRequired: 'Номер дома обязателен',
        firstNameRequired: 'Имя обязательно',
        lastNameRequired: 'Фамилия обязательна',
        middleNameRequired: 'Отчество обязательно',
        phoneTooShort: 'Слишком короткий телефон',
        phoneInvalid: 'Неверный номер телефона',
        passportRequired: 'Серия паспорта обязательна',
        passportInvalid: '2 заглавные латинские буквы и 7 цифр, всего 9 символов',
        pinflLength: 'PINFL состоит из {{length}} цифр',
        pinflDigitsOnly: 'Только цифры',
      },
    },
    claim: {
      title: 'Отслеживание посылки',
      subtitle: 'Введите PINFL и Trek ID',
      sectionTitle: 'Добавить в отслеживание',
      sectionDescription:
        'Отслеживайте посылку, созданную другим пользователем, по PINFL и Trek ID.',
      pinfl: 'PINFL',
      pinflPlaceholder: '{{length}} цифр',
      trekId: 'Trek ID',
      trekIdPlaceholder: 'ABC123456',
      submit: 'Добавить',
      toast: {
        added: 'Посылка добавлена в отслеживание',
      },
      errors: {
        pinflLength: 'PINFL состоит из {{length}} цифр',
        pinflDigitsOnly: 'Только цифры',
        trekIdMin: 'Trek ID минимум 5 символов',
        tooLong: 'Слишком длинно',
        trekIdInvalid: 'Только латиница, цифры, дефис',
      },
    },
    cargoId: {
      title: 'Cargo ID',
      loadError: 'Не удалось загрузить Cargo ID',
      requestAction: 'Получить Cargo ID',
      connectAction: 'Подключиться к Cargo ID',
      emptyTitle: 'Cargo ID пока нет',
      emptyDescription: 'Получите Cargo ID — после этого вы сможете создавать посылки.',
      profileBanner: {
        label: 'Cargo ID',
        helper: 'Вы можете создавать посылки',
        noneTitle: 'Cargo ID пока нет',
        noneHelper: 'Получите Cargo ID — после этого вы сможете создавать посылки.',
        getCta: 'Получить Cargo ID',
        connectCta: 'Подключиться к Cargo ID',
        copy: 'Копировать',
        copied: 'Cargo ID скопирован',
        copyFailed: 'Не удалось скопировать',
      },
      debt: {
        label: 'Задолженность',
        none: 'Задолженности нет',
        title: 'Задолженность',
        total: 'Общий долг',
        loadError: 'Не удалось загрузить задолженность',
        emptyHelper: 'Все услуги оплачены.',
        otherServices: 'Другие услуги',
        packageLine: 'Пакет {{name}} · {{date}}',
        openParcelHint: 'Нажмите на посылку, чтобы открыть подробности.',
      },
      parcelGate: {
        label: 'Нужен Cargo ID',
        dialogTitle: 'Нужен Cargo ID',
        dialogDescription:
          'Чтобы создать посылку, сначала получите Cargo ID.',
        noneTitle: 'Cargo ID пока нет',
        noneHelper: 'Чтобы создать посылку, сначала получите Cargo ID — он выдаётся сразу.',
        getCta: 'Получить Cargo ID',
        cancel: 'Отмена',
      },
      entityType: {
        PHYSICAL: 'Физическое',
        LEGAL: 'Юридическое',
      },
      actions: {
        unbind: 'Отвязать от аккаунта',
      },
      fields: {
        fullName: 'Полное имя',
        phone: 'Номер телефона',
        phonePlaceholder: '+998901234567',
      },
      request: {
        title: 'Получить Cargo ID',
        subtitle: 'Заполните данные',
        submit: 'Получить Cargo ID',
        typeLabel: 'Тип лица',
      },
      connect: {
        title: 'Подключиться к Cargo ID',
        submit: 'Подключиться',
        fields: {
          code: 'CID-12345',
          codeLabel: 'Код Cargo ID',
        },
        toast: {
          connected: 'Подключено',
        },
        errors: {
          notFound: 'Cargo ID не найден',
        },
      },
      confirmUnbindTitle: 'Отвязать Cargo ID от аккаунта?',
      confirmUnbindDescription: 'Cargo ID будет отвязан от вашего аккаунта, но останется в системе — позже вы сможете подключиться снова.',
      toast: {
        issued: 'Cargo ID выдан: {{code}}',
        deleted: 'Cargo ID отвязан от аккаунта',
      },
      errors: {
        fullNameRequired: 'Укажите полное имя',
        phoneRequired: 'Номер телефона обязателен',
        codeRequired: 'Код Cargo ID обязателен',
        tooLong: 'Слишком длинно',
      },
    },
    declaration: {
      title: 'Декларация',
      addProduct: 'Добавить товар',
      save: 'Сохранить',
      submit: 'Отправить на подтверждение',
      confirmTitle: 'Отправить на подтверждение?',
      confirmDescription:
        'После отправки посылки на модерацию вы не сможете её редактировать.',
      confirmAction: 'Да, отправить',
      loadCategoriesError: 'Не удалось загрузить категории',
      product: 'Товар #{{index}}',
      remove: 'Удалить',
      category: 'Категория',
      categoryPlaceholder: 'Выберите',
      subcategory: 'Подкатегория',
      subcategoryPlaceholder: 'Выберите',
      subcategoryPlaceholderDisabled: 'Сначала выберите категорию',
      fullName: 'Полное название',
      fullNamePlaceholder: 'iPhone 15 Pro 256GB',
      quantity: 'Количество',
      unitPrice: 'Цена за шт. (USD)',
      limitLoading: 'Загрузка лимита PINFL…',
      limitNotFound: 'Лимит PINFL не найден',
      limitTitle: 'Лимит:',
      noLimitLegal: 'Для юридического лица лимит не действует',
      used: 'Использовано: {{amount}}',
      now: 'Сейчас: {{amount}}',
      notEnough: 'Лимит превышен',
      remaining: 'Остаток: {{amount}}',
      overLimit: 'Превышение лимита на {{amount}}',
      resetHint: 'Лимит обновится {{date}}',
      validation: {
        atLeastOne: 'Нужен хотя бы 1 товар',
        productPrefix: 'Товар #{{index}}: {{message}}',
        check: 'проверьте',
        incomplete: 'Форма заполнена не полностью',
        // Advisory only — exceeding the PINFL limit no longer blocks submission.
        limitNotEnough: 'Лимит превышен',
      },
      toast: {
        saved: 'Товары сохранены',
        submitted: 'Посылка отправлена на подтверждение',
      },
      errors: {
        categorySelect: 'Выберите категорию',
        categoryRequired: 'Категория обязательна',
        subcategorySelect: 'Выберите подкатегорию',
        subcategoryRequired: 'Подкатегория обязательна',
        fullNameRequired: 'Название товара обязательно',
        tooLong: 'Слишком длинно',
        quantityInt: 'Только целое число',
        quantityMin: 'Минимум 1 шт.',
        priceMin: 'Введите цену',
        priceMax: 'Слишком много',
        priceDecimals: 'Не более 2 знаков после запятой',
      },
    },
    profile: {
      title: 'Профиль',
      loadError: 'Не удалось загрузить профиль',
      debts: {
        title: 'Долги по прибывшим посылкам',
        total: 'Общий долг',
        error: 'Не удалось загрузить долги',
      },
      receipts: {
        title: 'Платёжные чеки',
        number: 'Чек №{{number}}',
        download: 'Скачать',
        error: 'Не удалось загрузить чеки',
      },
      changePhoto: 'Изменить фото',
      addLanguage: 'Добавить',
      removeLanguage: 'Удалить {{language}}',
      languagesPlaceholder: 'Язык',
      fields: {
        email: 'Email',
        firstName: 'Имя',
        lastName: 'Фамилия',
        phone: 'Номер телефона',
        languages: 'Языки общения',
      },
      toast: {
        saved: 'Профиль обновлён',
        avatarUpdated: 'Фото обновлено',
      },
      errors: {
        tooLong: 'Слишком длинно',
        avatarType: 'Только изображение JPG, PNG или WEBP',
        avatarSize: 'Размер фото не должен превышать 5MB',
      },
      deleteAccount: {
        button: 'Удалить аккаунт',
        modal: {
          title: 'Удалить аккаунт?',
          description: 'Это действие необратимо. Ваши персональные данные (имя, email, привязка Google, телефон, уведомления, адреса, переписка поддержки) будут удалены. История посылок и платежей сохраняется анонимно для юридических требований.',
          confirm: 'Да, удалить',
          cancel: 'Отмена',
        },
        toast: {
          success: 'Ваш аккаунт удалён',
          error: 'Не удалось удалить аккаунт',
        },
      },
    },
    settings: {
      title: 'Настройки',
      account: 'Аккаунт',
      accountEmpty: 'Данные пользователя недоступны.',
      appInfo: 'О приложении',
      appSubtitle: 'Клиентское приложение',
      languageTitle: 'Язык',
      languageDescription: 'Выберите язык приложения',
      rows: {
        addresses: 'Мои получатели',
        onlineAddress: 'Адрес для онлайн-покупок',
        wikishop: 'Tez Japan Cargo Store',
        telegramBot: 'Подписаться на Telegram бота',
        telegramChannel: 'Подписаться на канал в Telegram',
        support: 'Поддержка',
        supportStaff: 'Технические помощники',
        language: 'Язык',
        comingSoon: 'Скоро',
      },
    },
    services: {
      sectionTitle: 'Услуги',
      additionalServices: 'Дополнительные услуги',
      techHelper: 'Помощь в покупке',
      sendPhoto: 'Отправить фото',
      sendVideo: 'Отправить видео',
      proverkaService: 'Проверка товара',
      returnService: 'Возврат посылки',
      splitParcel: 'Разделить посылку',
      selectParcel: 'Выберите посылку',
      noParcelsAvailable: 'Нет доступных посылок',
      contactInfo: 'Контактная информация',
      contactInfoHint: 'Имя пользователя или ссылка Telegram',
      contactInfoRequired: 'Укажите контактные данные',
      note: 'Комментарий',
      noteOptional: 'Комментарий (необязательно)',
      photoFee: 'Цена фото',
      videoFee: 'Цена видео',
      proverkaFee: 'Цена проверки',
      submit: 'Отправить',
      reportCreated: 'Запрос отправлен',
      reportError: 'Ошибка при отправке запроса',
      reportDuplicate: 'Запрос для этой посылки уже отправлен',
      reportNotOwned: 'Посылка не найдена или не принадлежит вам',
      photoTitle: 'Отправить фото',
      videoTitle: 'Отправить видео',
      proverkaTitle: 'Проверка товара',
      returnTitle: 'Возврат посылки',
      returnReason: 'Причина (необязательно)',
      returnFeeLabel: 'Цена возврата',
      returnCreated: 'Запрос на возврат отправлен',
      returnError: 'Ошибка при отправке запроса',
    },
    onlineAddress: {
      title: 'Адрес для онлайн-покупок',
      intro: 'Указывайте этот адрес при покупке в онлайн-магазинах США.',
      copy: 'Копировать',
      copied: 'Скопировано',
      copyFailed: 'Не удалось скопировать',
      fields: {
        fullName: 'Fullname (имя)',
        addressLine1: 'Address line 1 (первая строка адреса)',
        addressLine2: 'Address line 2 (ваш код)',
        city: 'City (город)',
        state: 'State (штат)',
        zipcode: 'Zipcode (индекс)',
        telephone: 'Telephone (номер телефона)',
      },
      warning:
        'Обратите внимание! В адресе обязательно должно быть указано STE 3, без этих символов посылка может быть доставлена по другому адресу. Если STE 3 не принимается в «Address line 1», его нужно ввести в «Address line 2».',
    },
    addresses: {
      title: 'Мои получатели',
      add: 'Добавить',
      edit: 'Редактировать',
      delete: 'Удалить',
      defaultBadge: 'Основной',
      emptyTitle: 'Получателей пока нет',
      emptyDescription: 'Сохраните адрес доставки, чтобы быстро заполнять формы.',
      confirmDeleteTitle: 'Удалить адрес?',
      confirmDeleteDescription: 'Это действие нельзя отменить.',
      confirmDeleteAction: 'Да, удалить',
      sectionAddress: 'Адрес получателя',
      sectionPersonal: 'Данные получателя',
      pageTitle: {
        create: 'Добавить адрес',
        edit: 'Редактировать адрес',
      },
      form: {
        addTitle: 'Новый адрес',
        editTitle: 'Редактировать адрес',
        label: 'Название',
        labelPlaceholder: 'Дом, Работа, ...',
        labelHelp:
          'Придумайте короткое название для адреса, например «Дом», «Работа» или «У родителей». Оно нужно, чтобы различать сохранённые адреса. Это не сам почтовый адрес.',
        addressName: 'Имя адреса',
        addressNamePlaceholder: 'Адрес получателя',
        addressNameHelp:
          'Укажите полный, настоящий адрес получателя — именно туда будет доставлена посылка.',
        region: 'Регион',
        city: 'Город',
        street: 'Улица',
        building: 'Дом',
        apartment: 'Квартира (необязательно)',
        additionalInfo: 'Дополнительные указания',
        isDefault: 'Сделать основным адресом',
      },
      toast: {
        created: 'Адрес добавлен',
        updated: 'Адрес обновлён',
        deleted: 'Адрес удалён',
      },
      errors: {
        labelRequired: 'Укажите название',
        addressNameRequired: 'Укажите имя адреса',
        regionRequired: 'Выберите регион',
        cityRequired: 'Укажите город',
        streetRequired: 'Укажите улицу',
        buildingRequired: 'Укажите дом',
        firstNameRequired: 'Имя обязательно',
        lastNameRequired: 'Фамилия обязательна',
        middleNameRequired: 'Отчество обязательно',
        phoneTooShort: 'Слишком короткий телефон',
        phoneInvalid: 'Неверный номер телефона',
        passportRequired: 'Серия паспорта обязательна',
        passportInvalid: '2 заглавные латинские буквы и 7 цифр, всего 9 символов',
        pinflLength: 'PINFL состоит из {{length}} цифр',
        pinflDigitsOnly: 'Только цифры',
        tooLong: 'Слишком длинно',
      },
    },
    splits: {
      title: 'Разделить посылку',
      start: 'Разделить посылку',
      subtitle: 'Добавьте получателей',
      trek: 'Трек: {{trekId}}',
      loadError: 'Не удалось загрузить разделение',
      notFound: 'Разделение не найдено',
      parcelTotal: 'Стоимость посылки',
      serviceFee: 'Сервисный сбор',
      createdAt: 'Дата создания',
      statusLabel: 'Статус',
      status: {
        DRAFT: 'Черновик',
        IN_PROGRESS: 'В процессе',
        DELIVERED: 'Доставлено',
      },
      sectionTargets: 'Получатели',
      sectionTargetsCount: '{{count}} получателей',
      targetTitle: 'Получатель {{index}}',
      addTarget: 'Добавить получателя',
      removeTarget: 'Удалить',
      sectionAddress: 'Адрес получателя',
      sectionPersonal: 'Данные получателя',
      save: 'Сохранить',
      saveTargets: 'Сохранить',
      reservedAmount: 'Зарезервировано',
      totalAmount: 'Итого',
      targetsEmpty: 'Получателей пока нет',
      limit: 'Лимит',
      sectionProducts: 'Товары',
      detailsShow: 'Подробнее',
      detailsHide: 'Свернуть',
      packageInfo: 'Информация о пакете',
      allocatedProducts: 'Выделенные товары',
      editableHint: 'Редактирование возможно только в статусе черновика',
      pickRecipient: {
        title: 'Мои получатели',
        placeholder: 'Выберите из сохранённых получателей',
        autoFillHint: 'Данные получателя заполнятся автоматически',
        noName: 'Получатель без имени',
      },
      toast: {
        created: 'Разделение создано',
        targetsSaved: 'Получатели сохранены',
      },
      fields: {
        pinfl: 'PINFL',
        pinflPlaceholder: '{{length}} цифр',
        lastName: 'Фамилия',
        firstName: 'Имя',
        middleName: 'Отчество',
        phone: 'Номер телефона',
        phonePlaceholder: '+998901234567',
        passport: 'Серия и номер паспорта',
        passportPlaceholder: 'AA1234567',
        addressName: 'Имя адреса',
        region: 'Регион',
        city: 'Город',
        street: 'Улица',
        building: 'Дом',
        apartment: 'Квартира (необязательно)',
        additionalInfo: 'Дополнительные указания',
        packageName: 'Название пакета',
        packageNamePlaceholder: 'Сгенерируйте название',
        packageWeight: 'Вес',
        packageWeightUnit: 'Единица',
        packagePrice: 'Цена пакета',
      },
      package: {
        generateName: 'Сгенерировать название',
        downloadQr: 'Скачать QR',
      },
      distribution: {
        title: 'Распределение товаров',
        noProducts: 'Товаров нет',
        available: 'всего × {{count}}',
        error: 'Каждый товар должен быть распределён полностью и точно:',
        mismatchLine: '{{name}}: распределено {{allocated}} / {{expected}}',
      },
      errors: {
        pinflLength: 'PINFL состоит из {{length}} цифр',
        pinflDigitsOnly: 'Только цифры',
        pinflDuplicate: 'Этот ПИНФЛ уже используется у другого получателя',
        firstNameRequired: 'Имя обязательно',
        lastNameRequired: 'Фамилия обязательна',
        middleNameRequired: 'Отчество обязательно',
        phoneTooShort: 'Слишком короткий телефон',
        phoneInvalid: 'Неверный номер телефона',
        passportRequired: 'Серия паспорта обязательна',
        passportInvalid: '2 заглавные латинские буквы и 7 цифр, всего 9 символов',
        addressNameRequired: 'Укажите имя адреса',
        regionRequired: 'Выберите регион',
        cityRequired: 'Укажите город',
        streetRequired: 'Укажите улицу',
        buildingRequired: 'Укажите дом',
        packageNameRequired: 'Сгенерируйте название пакета',
        weightRequired: 'Укажите вес',
        weightInvalid: 'Вес должен быть больше 0',
        weightUnitRequired: 'Выберите единицу',
        quantityInvalid: 'Неверное количество',
        tooLong: 'Слишком длинно',
        targetsMin: 'Добавьте хотя бы одного получателя',
      },
    },
    login: {
      tagline: 'Управляйте посылками из Японии в Узбекистан',
      signIn: 'Вход в систему',
      googlePrompt: 'Войдите через аккаунт Google, чтобы продолжить.',
      terms: 'Входя, вы соглашаетесь с условиями обслуживания.',
      devTitle: 'Dev: вход по токенам',
      devAccessLabel: 'Access token',
      devRefreshLabel: 'Refresh token',
      devSubmit: 'Сохранить и войти',
      googleSignIn: 'Войти через Google',
      apple: 'Войти через Apple',
      signingIn: 'Вход в систему',
      bridgeNoResponse: 'Мост не ответил',
      googleCancelled: 'Вход через Google отменён',
      googleNotConfigured: 'Google Client ID не настроен',
      googleConfigHint:
        'Укажите значение VITE_GOOGLE_CLIENT_ID в файле .env или войдите через мост Flutter.',
    },
    support: {
      title: 'Поддержка',
      faqTitle: 'Часто задаваемые вопросы',
      faqEmpty: 'Пока нет вопросов',
      contact: 'Связаться',
      contactHint: 'Если есть вопрос, напишите администратору',
      chatTitle: 'Чат с администратором',
      chatLoadError: 'Не удалось загрузить чат',
      chatEmpty: 'Сообщений пока нет. Напишите первое сообщение.',
      placeholder: 'Введите сообщение…',
      send: 'Отправить',
      attach: 'Прикрепить файл',
      removeAttachment: 'Удалить файл',
      imageAlt: 'Прикреплённое изображение',
      download: 'Скачать',
      blocked: 'Вы заблокированы — сообщение не отправлено',
      blockedBanner: 'Вы заблокированы. Отправка сообщений недоступна.',
      fileTooLarge: 'Размер файла не должен превышать 5MB',
      sendError: 'Не удалось отправить сообщение',
    },
    supportStaff: {
      title: 'Технические помощники',
      contact: 'Связаться',
      experience: 'Стаж работы: {{years}} лет',
      languages: 'Языки',
      emptyTitle: 'Помощников пока нет',
      emptyDescription: 'Технические помощники появятся в ближайшее время.',
      error: 'Ошибка загрузки данных',
    },
    notifications: {
      title: 'Уведомления',
      emptyTitle: 'Пока нет уведомлений',
      emptyDescription: 'Новые сообщения появятся здесь.',
      markAllRead: 'Отметить все как прочитанные',
      loadMore: 'Показать ещё',
      unread: 'Новое',
      imageAlt: 'Изображение уведомления',
      timeAgo: '{{value}} назад',
      justNow: 'только что',
      announcementTitle: 'Объявление',
      close: 'Закрыть',
      viewReceipt: 'Посмотреть чек',
    },
    notFound: {
      title: 'Страница не найдена',
      description: 'Запрошенная страница не существует или была удалена.',
      goHome: 'На главную',
    },
    tracking: {
      title: 'Отслеживание',
      inputLabel: 'Trek ID',
      inputPlaceholder: 'ABC123456',
      submit: 'Проверить',
      submitSave: 'Сохранить',
      resultLabel: 'Trek ID',
      loadError: 'Не удалось проверить статус',
      save: 'Сохранить',
      unsave: 'Убрать из сохранённых',
      savedBadge: 'Сохранено',
      savedListTitle: 'Сохранённые Trek ID',
      savedEmpty: 'Пока ничего не сохранено',
      removeSaved: 'Убрать из списка',
      confirmRemoveTitle: 'Удалить trek ID из сохранённых?',
      confirmRemoveDescription: '{{trekId}} будет удалён из сохранённых.',
      errors: {
        invalidFormat: 'Только буквы и цифры (5–255 символов)',
      },
      state: {
        not_found: 'Не найден',
        waiting: 'Ожидается',
        collecting: 'Сбор',
        in_party: 'В партии',
      },
      hint: {
        not_found: 'Этот Trek ID не поступал на склад.',
        waiting: 'Поступил на склад, но владелец не создал посылку.',
        collecting: 'Клиент подтвердил отправку.',
        in_party: 'Посылка в партии.',
      },
      toast: {
        saved: 'Trek ID сохранён',
        removed: 'Trek ID удалён из списка',
      },
    },
    receipt: {
      paid: 'Оплачено',
      brandTagline: 'Надёжная доставка из Японии в Узбекистан',
      receiptNumber: 'Номер чека',
      date: 'Дата',
      customer: 'Клиент',
      cargoId: 'Cargo ID',
      parcel: 'Посылка',
      trekId: 'Trek ID',
      service: 'Услуга',
      downloadPdf: 'Скачать PDF',
      back: 'Назад',
      footer: 'Официальный чек об оплате · Tez Cargo',
      notFoundTitle: 'Чек не найден',
      notFoundDescription: 'Такой чек не существует или ссылка неверна.',
      loadError: 'Не удалось загрузить чек',
      retry: 'Повторить',
    },
    payments: {
      title: 'История платежей',
      subtitle: 'Все ваши чеки об оплате',
      view: 'Открыть',
      pdf: 'PDF',
      number: 'Чек №{{number}}',
      emptyTitle: 'Платежей нет',
      emptyDescription: 'Ваши платежи появятся здесь.',
      viewAll: 'Показать все',
      loadError: 'Не удалось загрузить чеки',
      retry: 'Повторить',
    },
  },
  en: {
    common: {
      language: 'Language',
      uzbek: 'Oʻzbekcha',
      russian: 'Русский',
      english: 'English',
      kazakh: 'Қазақша',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      delete: 'Delete',
      retry: 'Retry',
      loading: 'Loading',
      help: 'Help',
      errorGeneric: 'Something went wrong',
      total: 'Total',
      logout: 'Sign out',
      loggedOut: 'Signed out',
      loginSuccess: 'Signed in successfully',
      loginError: 'Sign-in failed',
      flutterBridgeMissing: 'Flutter bridge is not available',
      tokensSaved: 'Tokens saved',
      errorBoundary: {
        title: 'Something went wrong',
        description: 'Please try again. If the problem persists, return to the home page.',
        retry: 'Retry',
        goHome: 'Go to home page',
      },
    },
    nav: {
      parcels: 'Parcels',
      parcelsShort: 'Parcels',
      packages: 'Packages',
      create: 'New parcel',
      createShort: 'Create',
      claim: 'Add to tracking',
      claimShort: 'Search',
      track: 'Tracking',
      ids: 'Cargo ID',
      support: 'Support',
      settings: 'Settings',
      sidebar: 'Side navigation',
      main: 'Main navigation',
      expand: 'Expand menu',
      collapse: 'Collapse menu',
    },
    packages: {
      title: 'Packages',
      detailTitle: 'Package',
      notMineLabel: "Another customer's parcel",
      detailNotFound: 'Package not found',
      loadError: 'Failed to load packages',
      listEmpty: 'No packages yet',
      noParcels: 'You have no parcels in this package',
      parcelsCount_one: '{{count}} parcel',
      parcelsCount_other: '{{count}} parcels',
      parcelsCount: '{{count}} parcels',
      batafsil: 'Details',
      sections: {
        info: 'Package details',
        parcels: 'Parcels ({{count}})',
      },
      fields: {
        name: 'Name',
        price: 'Price',
        weight: 'Weight',
        createdAt: 'Created',
      },
    },
    regions: {
      TASHKENT_CITY: 'Tashkent City',
      TASHKENT: 'Tashkent Region',
      FERGANA: 'Fergana',
      ANDIJAN: 'Andijan',
      NAMANGAN: 'Namangan',
      SAMARKAND: 'Samarkand',
      BUKHARA: 'Bukhara',
      SIRDARYA: 'Sirdaryo',
      SURKHANDARYA: 'Surkhandarya',
      NAVOI: 'Navoi',
      QASHQADARYA: 'Kashkadarya',
      KHOREZM: 'Khorezm',
      JIZZAKH: 'Jizzakh',
      KARAKALPAKSTAN: 'Karakalpakstan',
      XIVA: 'Khiva',
    },
    parcelStatus: {
      DRAFT: 'Draft',
      PENDING: 'Pending',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      all: 'All',
    },
    fulfillment: {
      WAITING: 'Waiting',
      CONFIRMED: 'Collecting',
      PACKAGED: 'Packaged',
    },
    partyStatus: {
      COLLECTING: 'Packaging',
      SHIPPING: 'Shipping',
      ON_THE_WAY: 'On the way',
      ON_CUSTOMS: 'At customs',
      LOCAL_ON_THE_WAY: 'Arrived at warehouse',
      SHIPMENT_ON_CUSTOMERS: 'Delivered',
    },
    clientStatus: {
      IN_PROGRESS: 'Expected',
      SORTING: 'At warehouse',
      COLLECTING: 'Packaging',
      SHIPPING: 'Shipping',
      ON_THE_WAY: 'On the way',
      ON_CUSTOMS: 'At customs',
      LOCAL_ON_THE_WAY: 'Arrived at warehouse',
      SHIPMENT_ON_CUSTOMERS: 'Delivered',
    },
    parcels: {
      title: 'My parcels',
      subtitle: 'Add a new parcel or track one',
      track: 'Track',
      searchPlaceholder: 'Search by Trek ID or name',
      loadError: 'Failed to load parcels',
      emptyFiltered: 'Nothing found for this filter',
      emptyTitle: 'No parcels yet',
      emptyDescription:
        'Create your first parcel or add an existing one to tracking via PINFL and Trek ID.',
      createParcel: 'Create parcel',
      claimParcel: 'Add to tracking',
      filterAll: 'All',
      filterByIdLabel: 'Filter by Cargo ID',
      trek: 'Trek: {{trekId}}',
      limitRemaining: 'Remaining limit',
      limitTotal: 'Total limit',
      noLimitLegal: 'No limit applies to legal entities',
      weight: '{{value}} kg',
      weightLabel: 'Weight',
      surchargeLabel: 'Service surcharge',
      surchargeApplied: 'Service surcharge added',
      splitLabel: 'Split parcel',
      deliveredToCustomer: 'Delivered to customer',
      confirmShipping: {
        select: 'Confirm shipping',
        action: 'Confirm shipping',
        selectedCount: '{{count}} selected',
        confirmTitle: 'Confirm shipping?',
        confirmDescription:
          "If you confirm shipping, the selected parcels move to the 'Collecting' state. Only an admin can revert this action. Do you want to continue?",
        confirmAction: 'Confirm shipping',
        notInWarehouse:
          'You will be able to confirm shipping once the parcel arrives at the warehouse',
        toast: {
          success: '{{count}} parcels confirmed for shipping',
          skipped: '{{count}} parcels were skipped',
        },
      },
      toast: {
        deleted: 'Parcel deleted',
      },
    },
    parcelDetail: {
      notFound: 'Parcel not found',
      rejectReason: 'Rejection reason:',
      sections: {
        address: 'Address',
        recipient: 'Recipient',
        recipients: 'Recipients',
        products: 'Products ({{count}})',
        party: 'Party',
      },
      partyName: 'Party name',
      partyStatusLabel: 'Party status',
      address: {
        name: 'Address name',
        region: 'Region',
        city: 'City',
        street: 'Street',
        note: 'Note',
      },
      recipient: {
        fullName: 'Full name',
        phone: 'Phone',
        passport: 'Passport',
        pinfl: 'PINFL',
        limit: 'Limit',
      },
      charges: {
        title: 'Services / Payments',
        paid: 'Paid',
        unpaid: 'Unpaid',
        free: 'Free',
        totalPayable: 'Total payable',
        types: {
          PACKAGE: 'Delivery',
          SPLIT: 'Parcel split',
          PHOTO: 'Photo request',
          VIDEO: 'Video request',
          PROVERKA: 'Product inspection',
          RETURN: 'Parcel return',
        },
      },
      pinflLimit: 'Limit: {{used}} / {{total}}',
      productsEmpty: 'No products added',
      declaration: 'Declaration',
      edit: 'Edit',
      delete: 'Delete',
      confirmDeleteTitle: 'Delete this parcel?',
      confirmDeleteApproved:
        'The approved parcel will be removed from the list, but the admin can still see it.',
      confirmDeleteDefault: 'This action cannot be undone.',
      confirmDeleteAction: 'Yes, delete',
    },
    parcelForm: {
      titleCreate: 'New parcel',
      titleEdit: 'Edit parcel',
      subtitle: 'Fill in the details',
      cancel: 'Cancel',
      save: 'Save',
      saveAndContinue: 'Save and continue',
      toast: {
        updated: 'Parcel updated',
        savedDraft: 'Parcel saved as draft',
      },
      sectionBasic: 'Basic information',
      sectionAddress: 'Recipient address',
      sectionPersonal: 'Recipient information',
      pickRecipient: {
        title: 'Choose recipient',
        placeholder: 'Choose a recipient',
        autoFillHint: 'Recipient details will fill in automatically',
        description: 'Choose a saved recipient — all fields will fill in automatically.',
        action: 'Choose',
        dialogTitle: 'Choose a recipient',
        searchPlaceholder: 'Search by name or phone',
        emptyTitle: 'No recipients yet',
        emptyAction: 'Add recipient',
        noMatches: 'Nothing found',
        appliedToast: 'Recipient details loaded',
        noName: 'Unnamed recipient',
        required: 'Select a recipient to continue',
      },
      fields: {
        name: 'Parcel name',
        namePlaceholder: 'iPhone 15 Pro',
        trekId: 'Trek ID',
        trekIdPlaceholder: 'ABC123456',
        storeName: 'Store name (optional)',
        storeNamePlaceholder: 'Amazon',
        addressName: 'Address name',
        addressNamePlaceholder: 'Home, Work, ...',
        region: 'Region',
        city: 'City',
        street: 'Street',
        building: 'Building number',
        apartment: 'Apartment (optional)',
        additionalInfo: 'Additional instructions',
        lastName: 'Last name',
        firstName: 'First name',
        middleName: 'Middle name',
        phone: 'Phone number',
        phonePlaceholder: '+998901234567',
        passport: 'Passport series and number',
        passportPlaceholder: 'AA1234567',
        pinfl: 'PINFL',
        pinflPlaceholder: '{{length}} digits',
      },
      pinfl: {
        checking: 'Checking limit…',
        loadError: 'Failed to get limit',
        remaining: 'Limit: {{used}} / {{total}}',
        noLimitLegal: 'No limit applies to legal entities',
      },
      errors: {
        nameMin: 'Parcel name must be at least 2 characters',
        tooLong: 'Too long',
        trekIdMin: 'Trek ID must be at least 5 characters',
        trekIdInvalid: 'Only latin letters, digits and hyphen',
        addressNameRequired: 'Address name is required',
        regionRequired: 'Select a region',
        cityRequired: 'City is required',
        streetRequired: 'Street is required',
        buildingRequired: 'Building number is required',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        middleNameRequired: 'Middle name is required',
        phoneTooShort: 'Phone number is too short',
        phoneInvalid: 'Invalid phone number',
        passportRequired: 'Passport series is required',
        passportInvalid: '2 uppercase Latin letters and 7 digits, 9 characters total',
        pinflLength: 'PINFL must be {{length}} digits',
        pinflDigitsOnly: 'Digits only',
      },
    },
    claim: {
      title: 'Track a parcel',
      subtitle: 'Enter PINFL and Trek ID',
      sectionTitle: 'Add to tracking',
      sectionDescription:
        'Track a parcel created by another user via PINFL and Trek ID.',
      pinfl: 'PINFL',
      pinflPlaceholder: '{{length}} digits',
      trekId: 'Trek ID',
      trekIdPlaceholder: 'ABC123456',
      submit: 'Add',
      toast: {
        added: 'Parcel added to tracking',
      },
      errors: {
        pinflLength: 'PINFL must be {{length}} digits',
        pinflDigitsOnly: 'Digits only',
        trekIdMin: 'Trek ID must be at least 5 characters',
        tooLong: 'Too long',
        trekIdInvalid: 'Only latin, digits, hyphen',
      },
    },
    cargoId: {
      title: 'Cargo ID',
      loadError: 'Failed to load Cargo ID',
      requestAction: 'Get a Cargo ID',
      connectAction: 'Connect to a Cargo ID',
      emptyTitle: 'No Cargo ID yet',
      emptyDescription: 'Get a Cargo ID — then you can start creating parcels.',
      profileBanner: {
        label: 'Cargo ID',
        helper: 'You can create parcels',
        noneTitle: 'No Cargo ID yet',
        noneHelper: 'Get a Cargo ID — then you can start creating parcels.',
        getCta: 'Get a Cargo ID',
        connectCta: 'Connect to a Cargo ID',
        copy: 'Copy',
        copied: 'Cargo ID copied',
        copyFailed: 'Could not copy',
      },
      debt: {
        label: 'Outstanding debt',
        none: 'No debt',
        title: 'Outstanding debt',
        total: 'Total owed',
        loadError: 'Could not load debt',
        emptyHelper: 'All services are paid for.',
        otherServices: 'Other services',
        packageLine: 'Package {{name}} · {{date}}',
        openParcelHint: 'Tap a parcel to see its details.',
      },
      parcelGate: {
        label: 'Cargo ID required',
        dialogTitle: 'Cargo ID required',
        dialogDescription:
          'To create a parcel you first need to get a Cargo ID.',
        noneTitle: 'No Cargo ID yet',
        noneHelper: 'To create a parcel you first need a Cargo ID — it is issued instantly.',
        getCta: 'Get a Cargo ID',
        cancel: 'Cancel',
      },
      entityType: {
        PHYSICAL: 'Individual',
        LEGAL: 'Legal entity',
      },
      actions: {
        unbind: 'Detach from account',
      },
      fields: {
        fullName: 'Full name',
        phone: 'Phone number',
        phonePlaceholder: '+998901234567',
      },
      request: {
        title: 'Get a Cargo ID',
        subtitle: 'Fill in the details',
        submit: 'Get Cargo ID',
        typeLabel: 'Entity type',
      },
      connect: {
        title: 'Connect to a Cargo ID',
        submit: 'Connect',
        fields: {
          code: 'CID-12345',
          codeLabel: 'Cargo ID code',
        },
        toast: {
          connected: 'Connected',
        },
        errors: {
          notFound: 'Cargo ID not found',
        },
      },
      confirmUnbindTitle: 'Detach Cargo ID from your account?',
      confirmUnbindDescription: 'The Cargo ID will be detached from your account but kept in the system — you can connect to it again later.',
      toast: {
        issued: 'Cargo ID issued: {{code}}',
        deleted: 'Cargo ID unlinked from your account',
      },
      errors: {
        fullNameRequired: 'Full name is required',
        phoneRequired: 'Phone number is required',
        codeRequired: 'Cargo ID code is required',
        tooLong: 'Too long',
      },
    },
    declaration: {
      title: 'Declaration',
      addProduct: 'Add product',
      save: 'Save',
      submit: 'Send for approval',
      confirmTitle: 'Send for approval?',
      confirmDescription:
        'After sending the parcel for moderation you will not be able to edit it.',
      confirmAction: 'Yes, send',
      loadCategoriesError: 'Failed to load categories',
      product: 'Product #{{index}}',
      remove: 'Delete',
      category: 'Category',
      categoryPlaceholder: 'Select',
      subcategory: 'Subcategory',
      subcategoryPlaceholder: 'Select',
      subcategoryPlaceholderDisabled: 'Select a category first',
      fullName: 'Full name',
      fullNamePlaceholder: 'iPhone 15 Pro 256GB',
      quantity: 'Quantity',
      unitPrice: 'Unit price (USD)',
      limitLoading: 'Loading PINFL limit…',
      limitNotFound: 'PINFL limit not found',
      limitTitle: 'Limit:',
      noLimitLegal: 'No limit applies to legal entities',
      used: 'Used: {{amount}}',
      now: 'Now: {{amount}}',
      notEnough: 'Over the limit',
      remaining: 'Remaining: {{amount}}',
      overLimit: 'Over limit by {{amount}}',
      resetHint: 'Limit resets on {{date}}',
      validation: {
        atLeastOne: 'At least 1 product is required',
        productPrefix: 'Product #{{index}}: {{message}}',
        check: 'check it',
        incomplete: 'The form is incomplete',
        // Advisory only — exceeding the PINFL limit no longer blocks submission.
        limitNotEnough: 'Over the limit',
      },
      toast: {
        saved: 'Products saved',
        submitted: 'Parcel sent for approval',
      },
      errors: {
        categorySelect: 'Select a category',
        categoryRequired: 'Category is required',
        subcategorySelect: 'Select a subcategory',
        subcategoryRequired: 'Subcategory is required',
        fullNameRequired: 'Product name is required',
        tooLong: 'Too long',
        quantityInt: 'Integer only',
        quantityMin: 'At least 1 piece',
        priceMin: 'Enter the price',
        priceMax: 'Too large',
        priceDecimals: 'At most 2 decimal places',
      },
    },
    profile: {
      title: 'Profile',
      loadError: 'Failed to load profile',
      debts: {
        title: 'Arrived parcel debts',
        total: 'Total debt',
        error: 'Failed to load debts',
      },
      receipts: {
        title: 'Payment receipts',
        number: 'Receipt #{{number}}',
        download: 'Download',
        error: 'Failed to load receipts',
      },
      changePhoto: 'Change photo',
      addLanguage: 'Add',
      removeLanguage: 'Remove {{language}}',
      languagesPlaceholder: 'Language',
      fields: {
        email: 'Email',
        firstName: 'First name',
        lastName: 'Last name',
        phone: 'Phone number',
        languages: 'Spoken languages',
      },
      toast: {
        saved: 'Profile updated',
        avatarUpdated: 'Photo updated',
      },
      errors: {
        tooLong: 'Too long',
        avatarType: 'Only JPG, PNG or WEBP image',
        avatarSize: 'Image must not exceed 5MB',
      },
      deleteAccount: {
        button: 'Delete account',
        modal: {
          title: 'Delete account?',
          description: 'This action is irreversible. Your personal data (name, email, Google link, phone, notifications, addresses, support chat) will be deleted. Parcel and payment history is kept anonymously for legal requirements.',
          confirm: 'Yes, delete',
          cancel: 'Cancel',
        },
        toast: {
          success: 'Your account has been deleted',
          error: 'Could not delete the account',
        },
      },
    },
    settings: {
      title: 'Settings',
      account: 'Account',
      accountEmpty: 'User information is not available.',
      appInfo: 'About the app',
      appSubtitle: 'Client app',
      languageTitle: 'Language',
      languageDescription: 'Choose the app language',
      rows: {
        addresses: 'My recipients',
        onlineAddress: 'Address for online shopping',
        wikishop: 'Tez Japan Cargo Store',
        telegramBot: 'Subscribe to Telegram bot',
        telegramChannel: 'Subscribe to Telegram channel',
        support: 'Support',
        supportStaff: 'Technical assistants',
        language: 'Language',
        comingSoon: 'Coming soon',
      },
    },
    services: {
      sectionTitle: 'Services',
      additionalServices: 'Additional services',
      techHelper: 'Buying assistance',
      sendPhoto: 'Send photo',
      sendVideo: 'Send video',
      proverkaService: 'Product inspection',
      returnService: 'Return parcel',
      splitParcel: 'Split parcel',
      selectParcel: 'Select a parcel',
      noParcelsAvailable: 'No available parcels',
      contactInfo: 'Contact info',
      contactInfoHint: 'Telegram username or link',
      contactInfoRequired: 'Please enter contact info',
      note: 'Note',
      noteOptional: 'Note (optional)',
      photoFee: 'Photo fee',
      videoFee: 'Video fee',
      proverkaFee: 'Inspection fee',
      submit: 'Submit',
      reportCreated: 'Request sent',
      reportError: 'Failed to send request',
      reportDuplicate: 'A request for this parcel has already been sent',
      reportNotOwned: 'Parcel not found or does not belong to you',
      photoTitle: 'Send photo',
      videoTitle: 'Send video',
      proverkaTitle: 'Product inspection',
      returnTitle: 'Return parcel',
      returnReason: 'Reason (optional)',
      returnFeeLabel: 'Return fee',
      returnCreated: 'Return request sent',
      returnError: 'Failed to send request',
    },
    onlineAddress: {
      title: 'Address for online shopping',
      intro: 'Use this address when buying from US online stores.',
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: 'Could not copy',
      fields: {
        fullName: 'Fullname',
        addressLine1: 'Address line 1',
        addressLine2: 'Address line 2 (your code)',
        city: 'City',
        state: 'State',
        zipcode: 'Zipcode',
        telephone: 'Telephone',
      },
      warning:
        'Please note! The address must include STE 3, without these characters the parcel may be delivered to a different address. If STE 3 is not accepted in “Address line 1”, enter it in “Address line 2”.',
    },
    addresses: {
      title: 'My recipients',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      defaultBadge: 'Default',
      emptyTitle: 'No recipients yet',
      emptyDescription: 'Save a delivery address to fill forms quickly.',
      confirmDeleteTitle: 'Delete address?',
      confirmDeleteDescription: 'This action cannot be undone.',
      confirmDeleteAction: 'Yes, delete',
      sectionAddress: 'Recipient address',
      sectionPersonal: 'Recipient information',
      pageTitle: {
        create: 'Add address',
        edit: 'Edit address',
      },
      form: {
        addTitle: 'New address',
        editTitle: 'Edit address',
        label: 'Label',
        labelPlaceholder: 'Home, Work, ...',
        labelHelp:
          'Give the address a short nickname, such as "Home", "Work" or "Parents". It helps you tell your saved addresses apart. It is not the actual street address.',
        addressName: 'Address name',
        addressNamePlaceholder: 'Recipient address',
        addressNameHelp:
          "Enter the recipient's full, real address — this is the exact place the parcel will be delivered to.",
        region: 'Region',
        city: 'City',
        street: 'Street',
        building: 'Building',
        apartment: 'Apartment (optional)',
        additionalInfo: 'Additional notes',
        isDefault: 'Set as default address',
      },
      toast: {
        created: 'Address added',
        updated: 'Address updated',
        deleted: 'Address deleted',
      },
      errors: {
        labelRequired: 'Label is required',
        addressNameRequired: 'Address name is required',
        regionRequired: 'Select a region',
        cityRequired: 'City is required',
        streetRequired: 'Street is required',
        buildingRequired: 'Building is required',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        middleNameRequired: 'Middle name is required',
        phoneTooShort: 'Phone number is too short',
        phoneInvalid: 'Invalid phone number',
        passportRequired: 'Passport series is required',
        passportInvalid: '2 uppercase Latin letters and 7 digits, 9 characters total',
        pinflLength: 'PINFL must be {{length}} digits',
        pinflDigitsOnly: 'Digits only',
        tooLong: 'Too long',
      },
    },
    splits: {
      title: 'Split parcel',
      start: 'Split parcel',
      subtitle: 'Add recipients',
      trek: 'Trek: {{trekId}}',
      loadError: 'Could not load split',
      notFound: 'Split not found',
      parcelTotal: 'Parcel value',
      serviceFee: 'Service fee',
      createdAt: 'Created at',
      statusLabel: 'Status',
      status: {
        DRAFT: 'Draft',
        IN_PROGRESS: 'In progress',
        DELIVERED: 'Delivered',
      },
      sectionTargets: 'Recipients',
      sectionTargetsCount: '{{count}} recipients',
      targetTitle: 'Recipient {{index}}',
      addTarget: 'Add recipient',
      removeTarget: 'Remove',
      sectionAddress: 'Recipient address',
      sectionPersonal: 'Recipient information',
      save: 'Save',
      saveTargets: 'Save',
      reservedAmount: 'Reserved',
      totalAmount: 'Total',
      targetsEmpty: 'No recipients yet',
      limit: 'Limit',
      sectionProducts: 'Products',
      detailsShow: 'Details',
      detailsHide: 'Collapse',
      packageInfo: 'Package info',
      allocatedProducts: 'Allocated products',
      editableHint: 'Editing is only available in draft status',
      pickRecipient: {
        title: 'My recipients',
        placeholder: 'Select a saved recipient',
        autoFillHint: 'Recipient details will be filled automatically',
        noName: 'Unnamed recipient',
      },
      toast: {
        created: 'Split created',
        targetsSaved: 'Recipients saved',
      },
      fields: {
        pinfl: 'PINFL',
        pinflPlaceholder: '{{length}} digits',
        lastName: 'Last name',
        firstName: 'First name',
        middleName: 'Middle name',
        phone: 'Phone number',
        phonePlaceholder: '+998901234567',
        passport: 'Passport series and number',
        passportPlaceholder: 'AA1234567',
        addressName: 'Address name',
        region: 'Region',
        city: 'City',
        street: 'Street',
        building: 'Building',
        apartment: 'Apartment (optional)',
        additionalInfo: 'Additional notes',
        packageName: 'Package name',
        packageNamePlaceholder: 'Generate a name',
        packageWeight: 'Weight',
        packageWeightUnit: 'Unit',
        packagePrice: 'Package price',
      },
      package: {
        generateName: 'Generate name',
        downloadQr: 'Download QR',
      },
      distribution: {
        title: 'Product distribution',
        noProducts: 'No products',
        available: 'total × {{count}}',
        error: 'Every product must be fully and exactly allocated:',
        mismatchLine: '{{name}}: allocated {{allocated}} / {{expected}}',
      },
      errors: {
        pinflLength: 'PINFL must be {{length}} digits',
        pinflDigitsOnly: 'Digits only',
        pinflDuplicate: 'This PINFL is already used for another recipient',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        middleNameRequired: 'Middle name is required',
        phoneTooShort: 'Phone number is too short',
        phoneInvalid: 'Invalid phone number',
        passportRequired: 'Passport series is required',
        passportInvalid: '2 uppercase Latin letters and 7 digits, 9 characters total',
        addressNameRequired: 'Address name is required',
        regionRequired: 'Select a region',
        cityRequired: 'City is required',
        streetRequired: 'Street is required',
        buildingRequired: 'Building is required',
        packageNameRequired: 'Generate a package name',
        weightRequired: 'Weight is required',
        weightInvalid: 'Weight must be greater than 0',
        weightUnitRequired: 'Select a unit',
        quantityInvalid: 'Invalid quantity',
        tooLong: 'Too long',
        targetsMin: 'Add at least one recipient',
      },
    },
    login: {
      tagline: 'Manage parcels from Japan to Uzbekistan',
      signIn: 'Sign in',
      googlePrompt: 'Sign in with your Google account to continue.',
      terms: 'By signing in you agree to the terms of service.',
      devTitle: 'Dev: sign in with tokens',
      devAccessLabel: 'Access token',
      devRefreshLabel: 'Refresh token',
      devSubmit: 'Save and sign in',
      googleSignIn: 'Sign in with Google',
      apple: 'Sign in with Apple',
      signingIn: 'Signing in',
      bridgeNoResponse: 'The bridge did not respond',
      googleCancelled: 'Google sign-in cancelled',
      googleNotConfigured: 'Google Client ID is not configured',
      googleConfigHint:
        'Set VITE_GOOGLE_CLIENT_ID in the .env file or sign in through the Flutter bridge.',
    },
    support: {
      title: 'Support',
      faqTitle: 'Frequently asked questions',
      faqEmpty: 'No questions yet',
      contact: 'Contact us',
      contactHint: 'Have a question? Chat with the administrator',
      chatTitle: 'Chat with administrator',
      chatLoadError: 'Failed to load chat',
      chatEmpty: 'No messages yet. Write your first message.',
      placeholder: 'Type a message…',
      send: 'Send',
      attach: 'Attach file',
      removeAttachment: 'Remove file',
      imageAlt: 'Attached image',
      download: 'Download',
      blocked: 'You are blocked — your message was not sent',
      blockedBanner: 'You are blocked. You cannot send messages.',
      fileTooLarge: 'File size must not exceed 5MB',
      sendError: 'Failed to send message',
    },
    supportStaff: {
      title: 'Technical assistants',
      contact: 'Contact',
      experience: 'Experience: {{years}} years',
      languages: 'Languages',
      emptyTitle: 'No assistants yet',
      emptyDescription: 'Technical assistants will be added soon.',
      error: 'Failed to load data',
    },
    notifications: {
      title: 'Notifications',
      emptyTitle: 'No notifications yet',
      emptyDescription: 'New messages will appear here.',
      markAllRead: 'Mark all as read',
      loadMore: 'Show more',
      unread: 'New',
      imageAlt: 'Notification image',
      timeAgo: '{{value}} ago',
      justNow: 'just now',
      announcementTitle: 'Announcement',
      close: 'Close',
      viewReceipt: 'View receipt',
    },
    notFound: {
      title: 'Page not found',
      description: "The page you're looking for doesn't exist or has been removed.",
      goHome: 'Go home',
    },
    tracking: {
      title: 'Tracking',
      inputLabel: 'Trek ID',
      inputPlaceholder: 'ABC123456',
      submit: 'Check',
      submitSave: 'Save',
      resultLabel: 'Trek ID',
      loadError: "Couldn't check the status",
      save: 'Save',
      unsave: 'Remove from saved',
      savedBadge: 'Saved',
      savedListTitle: 'Saved Trek IDs',
      savedEmpty: 'Nothing saved yet',
      removeSaved: 'Remove from list',
      confirmRemoveTitle: 'Remove this trek ID from saved?',
      confirmRemoveDescription: '{{trekId}} will be removed from your saved list.',
      errors: {
        invalidFormat: 'Letters and digits only (5–255 chars)',
      },
      state: {
        not_found: 'Not found',
        waiting: 'Waiting',
        collecting: 'Collecting',
        in_party: 'In party',
      },
      hint: {
        not_found: "This Trek ID hasn't arrived at the warehouse.",
        waiting: "Arrived at the warehouse but the owner hasn't created a parcel.",
        collecting: 'The customer confirmed shipping.',
        in_party: 'The parcel is in a party.',
      },
      toast: {
        saved: 'Trek ID saved',
        removed: 'Trek ID removed from list',
      },
    },
    receipt: {
      paid: 'Paid',
      brandTagline: 'Reliable delivery from Japan to Uzbekistan',
      receiptNumber: 'Receipt number',
      date: 'Date',
      customer: 'Customer',
      cargoId: 'Cargo ID',
      parcel: 'Parcel',
      trekId: 'Trek ID',
      service: 'Service',
      downloadPdf: 'Download PDF',
      back: 'Back',
      footer: 'Official payment receipt · Tez Cargo',
      notFoundTitle: 'Receipt not found',
      notFoundDescription: 'This receipt does not exist or the link is invalid.',
      loadError: 'Failed to load receipt',
      retry: 'Retry',
    },
    payments: {
      title: 'Payment history',
      subtitle: 'All your payment receipts',
      view: 'View',
      pdf: 'PDF',
      number: 'Receipt #{{number}}',
      emptyTitle: 'No payments',
      emptyDescription: 'Your payments will appear here.',
      viewAll: 'View all',
      loadError: 'Failed to load receipts',
      retry: 'Retry',
    },
  },
  kk: {
    common: {
      language: 'Тіл',
      uzbek: 'Oʻzbekcha',
      russian: 'Русский',
      english: 'English',
      kazakh: 'Қазақша',
      cancel: 'Бас тарту',
      save: 'Сақтау',
      confirm: 'Растау',
      back: 'Артқа',
      next: 'Келесі',
      delete: 'Жою',
      retry: 'Қайталау',
      loading: 'Жүктелуде',
      help: 'Көмек',
      errorGeneric: 'Қате орын алды',
      total: 'Барлығы',
      logout: 'Шығу',
      loggedOut: 'Жүйеден шықтыңыз',
      loginSuccess: 'Жүйеге сәтті кірдіңіз',
      loginError: 'Жүйеге кіру сәтсіз аяқталды',
      flutterBridgeMissing: 'Flutter көпірі қолжетімсіз',
      tokensSaved: 'Токендер сақталды',
      errorBoundary: {
        title: 'Күтпеген қате',
        description: 'Қайталап көріңіз. Мәселе шешілмесе, басты бетке оралыңыз.',
        retry: 'Қайталау',
        goHome: 'Басты бетке оралу',
      },
    },
    nav: {
      parcels: 'Сәлемдемелер',
      parcelsShort: 'Сәлемдеме',
      packages: 'Қораптар',
      create: 'Жаңа сәлемдеме',
      createShort: 'Құру',
      claim: 'Бақылауға қосу',
      claimShort: 'Іздеу',
      track: 'Бақылау',
      ids: 'Cargo ID',
      support: 'Көмек',
      settings: 'Баптаулар',
      sidebar: 'Бүйірлік мәзір',
      main: 'Негізгі мәзір',
      expand: 'Мәзірді ашу',
      collapse: 'Мәзірді жию',
    },
    packages: {
      title: 'Қораптар',
      detailTitle: 'Қорап',
      detailNotFound: 'Қорап табылмады',
      loadError: 'Қораптарды жүктеу мүмкін болмады',
      listEmpty: 'Әзірге қорап жоқ',
      noParcels: 'Бұл қорапта сіздің сәлемдемеңіз жоқ',
      parcelsCount_one: '{{count}} сәлемдеме',
      parcelsCount_other: '{{count}} сәлемдеме',
      parcelsCount: '{{count}} сәлемдеме',
      notMineLabel: 'Басқа клиенттің сәлемдемесі',
      batafsil: 'Толығырақ',
      sections: {
        info: 'Қорап туралы ақпарат',
        parcels: 'Сәлемдемелер ({{count}})',
      },
      fields: {
        name: 'Атауы',
        price: 'Бағасы',
        weight: 'Салмағы',
        createdAt: 'Құрылған күні',
      },
    },
    regions: {
      TASHKENT_CITY: 'Ташкент қаласы',
      TASHKENT: 'Ташкент облысы',
      FERGANA: 'Ферғана',
      ANDIJAN: 'Әндіжан',
      NAMANGAN: 'Наманған',
      SAMARKAND: 'Самарқанд',
      BUKHARA: 'Бұхара',
      SIRDARYA: 'Сырдария',
      SURKHANDARYA: 'Сурхандария',
      NAVOI: 'Науаи',
      QASHQADARYA: 'Қашқадария',
      KHOREZM: 'Хорезм',
      JIZZAKH: 'Жизақ',
      KARAKALPAKSTAN: 'Қарақалпақстан',
      XIVA: 'Хиуа',
    },
    parcelStatus: {
      DRAFT: 'Жоба',
      PENDING: 'Тексерілуде',
      APPROVED: 'Мақұлданды',
      REJECTED: 'Қабылданбады',
      all: 'Барлығы',
    },
    fulfillment: {
      WAITING: 'Күтілуде',
      CONFIRMED: 'Жиналуда',
      PACKAGED: 'Қапталды',
    },
    partyStatus: {
      COLLECTING: 'Қапталуда',
      SHIPPING: 'Жөнелтілуде',
      ON_THE_WAY: 'Жолда',
      ON_CUSTOMS: 'Кеденде',
      LOCAL_ON_THE_WAY: 'Қоймаға келді',
      SHIPMENT_ON_CUSTOMERS: 'Табысталды',
    },
    clientStatus: {
      IN_PROGRESS: 'Күтілуде',
      SORTING: 'Қоймада',
      COLLECTING: 'Қапталуда',
      SHIPPING: 'Жөнелтілуде',
      ON_THE_WAY: 'Жолда',
      ON_CUSTOMS: 'Кеденде',
      LOCAL_ON_THE_WAY: 'Қоймаға келді',
      SHIPMENT_ON_CUSTOMERS: 'Табысталды',
    },
    parcels: {
      title: 'Менің сәлемдемелерім',
      subtitle: 'Жаңа сәлемдеме қосыңыз немесе бақылаңыз',
      track: 'Бақылау',
      searchPlaceholder: 'Трек-нөмір немесе атау бойынша іздеу',
      loadError: 'Сәлемдемелерді жүктеу мүмкін болмады',
      emptyFiltered: 'Сүзгі бойынша ештеңе табылмады',
      emptyTitle: 'Әзірге сәлемдеме жоқ',
      emptyDescription:
        'Алғашқы сәлемдемеңізді құрыңыз немесе бар сәлемдемені ПИНФЛ мен трек-нөмір арқылы бақылауға қосыңыз.',
      createParcel: 'Сәлемдеме құру',
      claimParcel: 'Бақылауға қосу',
      filterAll: 'Барлығы',
      filterByIdLabel: 'Cargo ID бойынша сүзгі',
      trek: 'Трек: {{trekId}}',
      limitRemaining: 'Қалған лимит',
      limitTotal: 'Жалпы лимит',
      noLimitLegal: 'Заңды тұлға үшін лимит жоқ',
      weight: '{{value}} кг',
      weightLabel: 'Салмағы',
      surchargeLabel: 'Қызмет ақысы',
      surchargeApplied: 'Қызмет ақысы қосылды',
      splitLabel: 'Бөлінген сәлемдеме',
      deliveredToCustomer: 'Клиентке жеткізілді',
      confirmShipping: {
        select: 'Жөнелтуді растау',
        action: 'Жөнелтуді растау',
        selectedCount: 'Таңдалды: {{count}}',
        confirmTitle: 'Жөнелтуді растайсыз ба?',
        confirmDescription:
          'Жөнелтуді растасаңыз, таңдалған сәлемдемелер «Жиналуда» күйіне өтеді. Бұл әрекетті тек әкімші ғана кері қайтара алады. Жалғастырасыз ба?',
        confirmAction: 'Жөнелтуді растау',
        notInWarehouse:
          'Сәлемдеме қоймаға келгеннен кейін жөнелтуді растауға болады',
        toast: {
          success: '{{count}} сәлемдеменің жөнелтілуі расталды',
          skipped: '{{count}} сәлемдеме өткізіп жіберілді',
        },
      },
      toast: {
        deleted: 'Сәлемдеме жойылды',
      },
    },
    parcelDetail: {
      notFound: 'Сәлемдеме табылмады',
      rejectReason: 'Қабылданбау себебі:',
      sections: {
        address: 'Мекенжай',
        recipient: 'Алушы',
        recipients: 'Алушылар',
        products: 'Тауарлар ({{count}})',
        party: 'Партия',
      },
      partyName: 'Партия атауы',
      partyStatusLabel: 'Партия күйі',
      address: {
        name: 'Мекенжай атауы',
        region: 'Облыс',
        city: 'Қала',
        street: 'Көше',
        note: 'Ескертпе',
      },
      recipient: {
        fullName: 'Аты-жөні',
        phone: 'Телефон',
        passport: 'Төлқұжат',
        pinfl: 'ПИНФЛ',
        limit: 'Лимит',
      },
      charges: {
        title: 'Қызметтер / Төлемдер',
        paid: 'Төленген',
        unpaid: 'Төленбеген',
        free: 'Тегін',
        totalPayable: 'Төлеуге барлығы',
        types: {
          PACKAGE: 'Жеткізу',
          SPLIT: 'Сәлемдемені бөлу',
          PHOTO: 'Фото жіберу',
          VIDEO: 'Видео жіберу',
          PROVERKA: 'Тауарды тексеру',
          RETURN: 'Сәлемдемені қайтару',
        },
      },
      pinflLimit: 'Лимит: {{used}} / {{total}}',
      productsEmpty: 'Тауарлар қосылмаған',
      declaration: 'Декларация',
      edit: 'Өңдеу',
      delete: 'Жою',
      confirmDeleteTitle: 'Сәлемдемені жоясыз ба?',
      confirmDeleteApproved:
        'Мақұлданған сәлемдеме тізімнен алынады, бірақ әкімші оны көре алады.',
      confirmDeleteDefault: 'Бұл әрекетті болдырмау мүмкін емес.',
      confirmDeleteAction: 'Иә, жою',
    },
    parcelForm: {
      titleCreate: 'Жаңа сәлемдеме',
      titleEdit: 'Сәлемдемені өңдеу',
      subtitle: 'Деректерді толтырыңыз',
      cancel: 'Бас тарту',
      save: 'Сақтау',
      saveAndContinue: 'Сақтап жалғастыру',
      toast: {
        updated: 'Сәлемдеме жаңартылды',
        savedDraft: 'Сәлемдеме жоба ретінде сақталды',
      },
      sectionBasic: 'Негізгі деректер',
      sectionAddress: 'Алушының мекенжайы',
      sectionPersonal: 'Алушының деректері',
      pickRecipient: {
        title: 'Алушыны таңдау',
        placeholder: 'Алушыны таңдаңыз',
        autoFillHint: 'Алушының деректері автоматты түрде толтырылады',
        description: 'Сақталған алушыны таңдаңыз — барлық өріс автоматты түрде толтырылады.',
        action: 'Таңдау',
        dialogTitle: 'Алушыны таңдаңыз',
        searchPlaceholder: 'Аты немесе телефоны бойынша іздеу',
        emptyTitle: 'Әзірге алушылар жоқ',
        emptyAction: 'Алушы қосу',
        noMatches: 'Ештеңе табылмады',
        appliedToast: 'Алушының деректері жүктелді',
        noName: 'Аты жоқ алушы',
        required: 'Жалғастыру үшін алушыны таңдаңыз',
      },
      fields: {
        name: 'Сәлемдеме атауы',
        namePlaceholder: 'iPhone 15 Pro',
        trekId: 'Трек-нөмір',
        trekIdPlaceholder: 'ABC123456',
        storeName: 'Дүкен атауы (міндетті емес)',
        storeNamePlaceholder: 'Amazon',
        addressName: 'Мекенжай атауы',
        addressNamePlaceholder: 'Үй, Жұмыс, ...',
        region: 'Облыс',
        city: 'Қала',
        street: 'Көше',
        building: 'Үй нөмірі',
        apartment: 'Пәтер (міндетті емес)',
        additionalInfo: 'Қосымша нұсқаулар',
        lastName: 'Тегі',
        firstName: 'Аты',
        middleName: 'Әкесінің аты',
        phone: 'Телефон нөмірі',
        phonePlaceholder: '+998901234567',
        passport: 'Төлқұжат сериясы мен нөмірі',
        passportPlaceholder: 'AA1234567',
        pinfl: 'ПИНФЛ',
        pinflPlaceholder: '{{length}} цифр',
      },
      pinfl: {
        checking: 'Лимит тексерілуде…',
        loadError: 'Лимитті алу мүмкін болмады',
        remaining: 'Лимит: {{used}} / {{total}}',
        noLimitLegal: 'Заңды тұлға үшін лимит жоқ',
      },
      errors: {
        nameMin: 'Сәлемдеме атауы кемінде 2 таңба',
        tooLong: 'Тым ұзын',
        trekIdMin: 'Трек-нөмір кемінде 5 таңба',
        trekIdInvalid: 'Тек латын әріптері, цифрлар және сызықша',
        addressNameRequired: 'Мекенжай атауын енгізіңіз',
        regionRequired: 'Облысты таңдаңыз',
        cityRequired: 'Қаланы енгізіңіз',
        streetRequired: 'Көшені енгізіңіз',
        buildingRequired: 'Үй нөмірін енгізіңіз',
        firstNameRequired: 'Атын енгізіңіз',
        lastNameRequired: 'Тегін енгізіңіз',
        middleNameRequired: 'Әкесінің атын енгізіңіз',
        phoneTooShort: 'Телефон нөмірі тым қысқа',
        phoneInvalid: 'Телефон нөмірі қате',
        passportRequired: 'Төлқұжат сериясын енгізіңіз',
        passportInvalid: '2 бас латын әрпі және 7 цифр, барлығы 9 таңба',
        pinflLength: 'ПИНФЛ {{length}} цифрдан тұрады',
        pinflDigitsOnly: 'Тек цифрлар',
      },
    },
    claim: {
      title: 'Сәлемдемені бақылау',
      subtitle: 'ПИНФЛ мен трек-нөмірді енгізіңіз',
      sectionTitle: 'Бақылауға қосу',
      sectionDescription:
        'Басқа пайдаланушы құрған сәлемдемені ПИНФЛ мен трек-нөмір арқылы бақылаңыз.',
      pinfl: 'ПИНФЛ',
      pinflPlaceholder: '{{length}} цифр',
      trekId: 'Трек-нөмір',
      trekIdPlaceholder: 'ABC123456',
      submit: 'Қосу',
      toast: {
        added: 'Сәлемдеме бақылауға қосылды',
      },
      errors: {
        pinflLength: 'ПИНФЛ {{length}} цифрдан тұрады',
        pinflDigitsOnly: 'Тек цифрлар',
        trekIdMin: 'Трек-нөмір кемінде 5 таңба',
        tooLong: 'Тым ұзын',
        trekIdInvalid: 'Тек латын әріптері, цифрлар және сызықша',
      },
    },
    cargoId: {
      title: 'Cargo ID',
      loadError: 'Cargo ID жүктелмеді',
      requestAction: 'Cargo ID алу',
      connectAction: 'Cargo ID қосу',
      emptyTitle: 'Әзірге Cargo ID жоқ',
      emptyDescription: 'Cargo ID алыңыз — содан кейін сәлемдеме құра аласыз.',
      profileBanner: {
        label: 'Cargo ID',
        helper: 'Сәлемдеме құра аласыз',
        noneTitle: 'Әзірге Cargo ID жоқ',
        noneHelper: 'Cargo ID алыңыз — содан кейін сәлемдеме құра аласыз.',
        getCta: 'Cargo ID алу',
        connectCta: 'Cargo ID қосу',
        copy: 'Көшіру',
        copied: 'Cargo ID көшірілді',
        copyFailed: 'Көшіру мүмкін болмады',
      },
      debt: {
        label: 'Қарыз',
        none: 'Қарыз жоқ',
        title: 'Қарыз',
        total: 'Жалпы қарыз',
        loadError: 'Қарызды жүктеу мүмкін болмады',
        emptyHelper: 'Барлық қызмет төленген.',
        otherServices: 'Басқа қызметтер',
        packageLine: 'Қорап {{name}} · {{date}}',
        openParcelHint: 'Толығырақ көру үшін сәлемдемені басыңыз.',
      },
      parcelGate: {
        label: 'Cargo ID қажет',
        dialogTitle: 'Cargo ID қажет',
        dialogDescription:
          'Сәлемдеме құру үшін алдымен Cargo ID алуыңыз керек.',
        noneTitle: 'Әзірге Cargo ID жоқ',
        noneHelper: 'Сәлемдеме құру үшін алдымен Cargo ID алуыңыз керек — ол бірден беріледі.',
        getCta: 'Cargo ID алу',
        cancel: 'Бас тарту',
      },
      entityType: {
        PHYSICAL: 'Жеке тұлға',
        LEGAL: 'Заңды тұлға',
      },
      actions: {
        unbind: 'Аккаунттан ажырату',
      },
      fields: {
        fullName: 'Толық аты-жөні',
        phone: 'Телефон нөмірі',
        phonePlaceholder: '+998901234567',
      },
      request: {
        title: 'Cargo ID алу',
        subtitle: 'Деректерді толтырыңыз',
        submit: 'Cargo ID алу',
        typeLabel: 'Тұлға түрі',
      },
      connect: {
        title: 'Cargo ID қосу',
        submit: 'Қосылу',
        fields: {
          code: 'CID-12345',
          codeLabel: 'Cargo ID коды',
        },
        toast: {
          connected: 'Қосылды',
        },
        errors: {
          notFound: 'Cargo ID табылмады',
        },
      },
      confirmUnbindTitle: 'Cargo ID-ді аккаунттан ажыратасыз ба?',
      confirmUnbindDescription: 'Cargo ID аккаунтыңыздан ажыратылады, бірақ жүйеде сақталады — кейін оны қайта қоса аласыз.',
      toast: {
        issued: 'Cargo ID берілді: {{code}}',
        deleted: 'Cargo ID аккаунттан ажыратылды',
      },
      errors: {
        fullNameRequired: 'Толық аты-жөніңізді енгізіңіз',
        phoneRequired: 'Телефон нөмірін енгізіңіз',
        codeRequired: 'Cargo ID кодын енгізіңіз',
        tooLong: 'Тым ұзын',
      },
    },
    declaration: {
      title: 'Декларация',
      addProduct: 'Тауар қосу',
      save: 'Сақтау',
      submit: 'Растауға жіберу',
      confirmTitle: 'Растауға жібересіз бе?',
      confirmDescription:
        'Растауға жіберілген сәлемдемені өңдеу мүмкін болмайды.',
      confirmAction: 'Иә, жіберу',
      loadCategoriesError: 'Санаттар жүктелмеді',
      product: 'Тауар #{{index}}',
      remove: 'Жою',
      category: 'Санат',
      categoryPlaceholder: 'Таңдаңыз',
      subcategory: 'Ішкі санат',
      subcategoryPlaceholder: 'Таңдаңыз',
      subcategoryPlaceholderDisabled: 'Алдымен санатты таңдаңыз',
      fullName: 'Толық атауы',
      fullNamePlaceholder: 'iPhone 15 Pro 256GB',
      quantity: 'Саны',
      unitPrice: '1 дана бағасы (USD)',
      limitLoading: 'ПИНФЛ лимиті жүктелуде…',
      limitNotFound: 'ПИНФЛ лимиті табылмады',
      limitTitle: 'Лимит:',
      noLimitLegal: 'Заңды тұлға үшін лимит жоқ',
      used: 'Пайдаланылды: {{amount}}',
      now: 'Қазір: {{amount}}',
      notEnough: 'Лимиттен асты',
      remaining: 'Қалды: {{amount}}',
      overLimit: 'Лимиттен {{amount}} артық',
      resetHint: 'Лимит {{date}} жаңарады',
      validation: {
        atLeastOne: 'Кемінде 1 тауар қажет',
        productPrefix: 'Тауар #{{index}}: {{message}}',
        check: 'тексеріңіз',
        incomplete: 'Форма толық толтырылмаған',
        limitNotEnough: 'Лимиттен асып кетті',
      },
      toast: {
        saved: 'Тауарлар сақталды',
        submitted: 'Сәлемдеме растауға жіберілді',
      },
      errors: {
        categorySelect: 'Санатты таңдаңыз',
        categoryRequired: 'Санатты таңдаңыз',
        subcategorySelect: 'Ішкі санатты таңдаңыз',
        subcategoryRequired: 'Ішкі санатты таңдаңыз',
        fullNameRequired: 'Тауар атауын енгізіңіз',
        tooLong: 'Тым ұзын',
        quantityInt: 'Тек бүтін сан',
        quantityMin: 'Кемінде 1 дана',
        priceMin: 'Бағасын енгізіңіз',
        priceMax: 'Тым үлкен',
        priceDecimals: 'Үтірден кейін 2 таңбадан аспауы керек',
      },
    },
    profile: {
      title: 'Профиль',
      loadError: 'Профиль деректері жүктелмеді',
      debts: {
        title: 'Келген сәлемдемелер бойынша қарыз',
        total: 'Жалпы қарыз',
        error: 'Қарыздарды жүктеу мүмкін болмады',
      },
      receipts: {
        title: 'Төлем чектері',
        number: 'Чек №{{number}}',
        download: 'Жүктеп алу',
        error: 'Чектерді жүктеу мүмкін болмады',
      },
      changePhoto: 'Фотоны өзгерту',
      addLanguage: 'Қосу',
      removeLanguage: '{{language}} тілін жою',
      languagesPlaceholder: 'Тілді енгізіңіз',
      fields: {
        email: 'Email',
        firstName: 'Аты',
        lastName: 'Тегі',
        phone: 'Телефон нөмірі',
        languages: 'Сөйлесе алатын тілдер',
      },
      toast: {
        saved: 'Профиль жаңартылды',
        avatarUpdated: 'Фото жаңартылды',
      },
      errors: {
        tooLong: 'Тым ұзын',
        avatarType: 'Тек JPG, PNG немесе WEBP сурет',
        avatarSize: 'Сурет көлемі 5MB-тан аспауы керек',
      },
      deleteAccount: {
        button: 'Аккаунтты жою',
        modal: {
          title: 'Аккаунтты жоясыз ба?',
          description: 'Бұл әрекетті болдырмау мүмкін емес. Жеке деректеріңіз (аты, email, Google байланысы, телефон, хабарламалар, мекенжайлар, қолдау қызметімен хат алмасу) жойылады. Сәлемдемелер мен төлемдер тарихы заң талаптарына сәйкес анонимді түрде сақталады.',
          confirm: 'Иә, жою',
          cancel: 'Бас тарту',
        },
        toast: {
          success: 'Аккаунтыңыз жойылды',
          error: 'Аккаунтты жою мүмкін болмады',
        },
      },
    },
    settings: {
      title: 'Баптаулар',
      account: 'Аккаунт',
      accountEmpty: 'Пайдаланушы деректері жоқ.',
      appInfo: 'Қосымша туралы',
      appSubtitle: 'Клиент қосымшасы',
      languageTitle: 'Тіл',
      languageDescription: 'Қосымша тілін таңдаңыз',
      rows: {
        addresses: 'Менің алушыларым',
        onlineAddress: 'Онлайн сауда мекенжайы',
        wikishop: 'Tez Japan Cargo Store',
        telegramBot: 'Telegram ботқа жазылу',
        telegramChannel: 'Telegram арнаға жазылу',
        support: 'Көмек',
        supportStaff: 'Техникалық көмекшілер',
        language: 'Тіл',
        comingSoon: 'Жақында',
      },
    },
    services: {
      sectionTitle: 'Қызметтер',
      additionalServices: 'Қосымша қызметтер',
      techHelper: 'Сатып алуға көмек',
      sendPhoto: 'Фото жіберу',
      sendVideo: 'Видео жіберу',
      proverkaService: 'Тауарды тексеру',
      returnService: 'Сәлемдемені қайтару',
      splitParcel: 'Сәлемдемені бөлу',
      selectParcel: 'Сәлемдемені таңдаңыз',
      noParcelsAvailable: 'Қолжетімді сәлемдеме жоқ',
      contactInfo: 'Байланыс деректері',
      contactInfoHint: 'Telegram-дағы пайдаланушы аты немесе сілтеме',
      contactInfoRequired: 'Байланыс деректерін енгізіңіз',
      note: 'Түсініктеме',
      noteOptional: 'Түсініктеме (міндетті емес)',
      photoFee: 'Фото бағасы',
      videoFee: 'Видео бағасы',
      proverkaFee: 'Тексеру бағасы',
      submit: 'Жіберу',
      reportCreated: 'Сұраныс жіберілді',
      reportError: 'Сұранысты жіберу кезінде қате орын алды',
      reportDuplicate: 'Бұл сәлемдеме үшін мұндай сұраныс бұрын жіберілген',
      reportNotOwned: 'Сәлемдеме табылмады немесе сізге тиесілі емес',
      photoTitle: 'Фото жіберу',
      videoTitle: 'Видео жіберу',
      proverkaTitle: 'Тауарды тексеру',
      returnTitle: 'Сәлемдемені қайтару',
      returnReason: 'Себебі (міндетті емес)',
      returnFeeLabel: 'Қайтару бағасы',
      returnCreated: 'Қайтаруға сұраныс жіберілді',
      returnError: 'Сұранысты жіберу кезінде қате орын алды',
    },
    onlineAddress: {
      title: 'Онлайн сауда мекенжайы',
      intro: 'АҚШ онлайн дүкендерінен сатып алғанда осы мекенжайды көрсетіңіз.',
      copy: 'Көшіру',
      copied: 'Көшірілді',
      copyFailed: 'Көшіру мүмкін болмады',
      fields: {
        fullName: 'Fullname (аты-жөні)',
        addressLine1: 'Address line 1 (мекенжайдың бірінші жолы)',
        addressLine2: 'Address line 2 (сіздің кодыңыз)',
        city: 'City (қала)',
        state: 'State (штат)',
        zipcode: 'Zipcode (индекс)',
        telephone: 'Telephone (телефон нөмірі)',
      },
      warning:
        'Назар аударыңыз! Мекенжайда STE 3 міндетті түрде көрсетілуі керек, бұл белгілерсіз сәлемдеме басқа мекенжайға жеткізілуі мүмкін. Егер STE 3 «Address line 1» жолына қабылданбаса, оны «Address line 2» жолына енгізіңіз.',
    },
    addresses: {
      title: 'Менің алушыларым',
      add: 'Қосу',
      edit: 'Өңдеу',
      delete: 'Жою',
      defaultBadge: 'Негізгі',
      emptyTitle: 'Әзірге алушылар жоқ',
      emptyDescription: 'Формаларды тез толтыру үшін жеткізу мекенжайыңызды сақтап қойыңыз.',
      confirmDeleteTitle: 'Мекенжайды жоясыз ба?',
      confirmDeleteDescription: 'Бұл әрекетті болдырмау мүмкін емес.',
      confirmDeleteAction: 'Иә, жою',
      sectionAddress: 'Алушының мекенжайы',
      sectionPersonal: 'Алушының деректері',
      pageTitle: {
        create: 'Мекенжай қосу',
        edit: 'Мекенжайды өңдеу',
      },
      form: {
        addTitle: 'Жаңа мекенжай',
        editTitle: 'Мекенжайды өңдеу',
        label: 'Атауы',
        labelPlaceholder: 'Үй, Жұмыс, ...',
        labelHelp:
          'Мекенжайға өзіңізге түсінікті қысқа атау беріңіз, мысалы «Үй», «Жұмыс» немесе «Ата-анамның үйі». Бұл сақталған мекенжайларды бір-бірінен ажырату үшін керек. Бұл нақты көше мекенжайы емес.',
        addressName: 'Мекенжай атауы',
        addressNamePlaceholder: 'Алушының мекенжайы',
        addressNameHelp:
          'Алушының толық, нақты мекенжайын енгізіңіз — сәлемдеме дәл осы жерге жеткізіледі.',
        region: 'Облыс',
        city: 'Қала',
        street: 'Көше',
        building: 'Үй нөмірі',
        apartment: 'Пәтер (міндетті емес)',
        additionalInfo: 'Қосымша нұсқаулар',
        isDefault: 'Негізгі мекенжай ретінде белгілеу',
      },
      toast: {
        created: 'Мекенжай қосылды',
        updated: 'Мекенжай жаңартылды',
        deleted: 'Мекенжай жойылды',
      },
      errors: {
        labelRequired: 'Атауын енгізіңіз',
        addressNameRequired: 'Мекенжай атауын енгізіңіз',
        regionRequired: 'Облысты таңдаңыз',
        cityRequired: 'Қаланы енгізіңіз',
        streetRequired: 'Көшені енгізіңіз',
        buildingRequired: 'Үй нөмірін енгізіңіз',
        firstNameRequired: 'Атын енгізіңіз',
        lastNameRequired: 'Тегін енгізіңіз',
        middleNameRequired: 'Әкесінің атын енгізіңіз',
        phoneTooShort: 'Телефон нөмірі тым қысқа',
        phoneInvalid: 'Телефон нөмірі қате',
        passportRequired: 'Төлқұжат сериясын енгізіңіз',
        passportInvalid: '2 бас латын әрпі және 7 цифр, барлығы 9 таңба',
        pinflLength: 'ПИНФЛ {{length}} цифрдан тұрады',
        pinflDigitsOnly: 'Тек цифрлар',
        tooLong: 'Тым ұзын',
      },
    },
    splits: {
      title: 'Сәлемдемені бөлу',
      start: 'Сәлемдемені бөлу',
      subtitle: 'Алушыларды қосыңыз',
      trek: 'Трек: {{trekId}}',
      loadError: 'Бөлу деректерін жүктеу мүмкін болмады',
      notFound: 'Бөлу деректері табылмады',
      parcelTotal: 'Сәлемдеме құны',
      serviceFee: 'Қызмет ақысы',
      createdAt: 'Құрылған күні',
      statusLabel: 'Күйі',
      status: {
        DRAFT: 'Жоба',
        IN_PROGRESS: 'Орындалуда',
        DELIVERED: 'Жеткізілді',
      },
      sectionTargets: 'Алушылар',
      sectionTargetsCount: '{{count}} алушы',
      targetTitle: '{{index}}-алушы',
      addTarget: 'Алушы қосу',
      removeTarget: 'Жою',
      sectionAddress: 'Алушының мекенжайы',
      sectionPersonal: 'Алушының деректері',
      save: 'Сақтау',
      saveTargets: 'Сақтау',
      reservedAmount: 'Брондалған',
      totalAmount: 'Барлығы',
      targetsEmpty: 'Әзірге алушы жоқ',
      limit: 'Лимит',
      sectionProducts: 'Тауарлар',
      detailsShow: 'Толығырақ',
      detailsHide: 'Жасыру',
      packageInfo: 'Қорап туралы ақпарат',
      allocatedProducts: 'Бөлінген тауарлар',
      editableHint: 'Тек жоба күйінде өңдеуге болады',
      pickRecipient: {
        title: 'Менің алушыларым',
        placeholder: 'Сақталған алушылардан таңдаңыз',
        autoFillHint: 'Алушының деректері автоматты түрде толтырылады',
        noName: 'Атаусыз алушы',
      },
      toast: {
        created: 'Бөлу құрылды',
        targetsSaved: 'Алушылар сақталды',
      },
      fields: {
        pinfl: 'ПИНФЛ',
        pinflPlaceholder: '{{length}} цифр',
        lastName: 'Тегі',
        firstName: 'Аты',
        middleName: 'Әкесінің аты',
        phone: 'Телефон нөмірі',
        phonePlaceholder: '+998901234567',
        passport: 'Төлқұжат сериясы мен нөмірі',
        passportPlaceholder: 'AA1234567',
        addressName: 'Мекенжай атауы',
        region: 'Облыс',
        city: 'Қала',
        street: 'Көше',
        building: 'Үй нөмірі',
        apartment: 'Пәтер (міндетті емес)',
        additionalInfo: 'Қосымша нұсқаулар',
        packageName: 'Қорап атауы',
        packageNamePlaceholder: 'Атау жасаңыз',
        packageWeight: 'Салмағы',
        packageWeightUnit: 'Өлшем бірлігі',
        packagePrice: 'Қорап бағасы',
      },
      package: {
        generateName: 'Атау жасау',
        downloadQr: 'QR жүктеп алу',
      },
      distribution: {
        title: 'Тауарларды бөлу',
        noProducts: 'Тауарлар жоқ',
        available: 'барлығы × {{count}}',
        error: 'Әр тауар толық әрі дәл бөлінуі керек:',
        mismatchLine: '{{name}}: бөлінгені {{allocated}} / {{expected}}',
      },
      errors: {
        pinflLength: 'ПИНФЛ {{length}} цифрдан тұрады',
        pinflDigitsOnly: 'Тек цифрлар',
        pinflDuplicate: 'Бұл ПИНФЛ басқа алушыда қолданылған',
        firstNameRequired: 'Атын енгізіңіз',
        lastNameRequired: 'Тегін енгізіңіз',
        middleNameRequired: 'Әкесінің атын енгізіңіз',
        phoneTooShort: 'Телефон нөмірі тым қысқа',
        phoneInvalid: 'Телефон нөмірі қате',
        passportRequired: 'Төлқұжат сериясын енгізіңіз',
        passportInvalid: '2 бас латын әрпі және 7 цифр, барлығы 9 таңба',
        addressNameRequired: 'Мекенжай атауын енгізіңіз',
        regionRequired: 'Облысты таңдаңыз',
        cityRequired: 'Қаланы енгізіңіз',
        streetRequired: 'Көшені енгізіңіз',
        buildingRequired: 'Үй нөмірін енгізіңіз',
        packageNameRequired: 'Қорап атауын жасаңыз',
        weightRequired: 'Салмағын енгізіңіз',
        weightInvalid: 'Салмақ 0-ден үлкен болуы керек',
        weightUnitRequired: 'Өлшем бірлігін таңдаңыз',
        quantityInvalid: 'Саны қате',
        tooLong: 'Тым ұзын',
        targetsMin: 'Кемінде бір алушы қосыңыз',
      },
    },
    login: {
      tagline: 'Жапониядан Өзбекстанға сәлемдемелеріңізді басқарыңыз',
      signIn: 'Кіру',
      googlePrompt: 'Жалғастыру үшін Google аккаунтыңызбен кіріңіз.',
      terms: 'Кіру арқылы қызмет көрсету шарттарымен келісесіз.',
      devTitle: 'Dev: токендер арқылы кіру',
      devAccessLabel: 'Access token',
      devRefreshLabel: 'Refresh token',
      devSubmit: 'Сақтау және кіру',
      googleSignIn: 'Google арқылы кіру',
      apple: 'Apple арқылы кіру',
      signingIn: 'Жүйеге кіру орындалуда',
      bridgeNoResponse: 'Көпір жауап бермеді',
      googleCancelled: 'Google арқылы кіруден бас тартылды',
      googleNotConfigured: 'Google Client ID бапталмаған',
      googleConfigHint: '.env файлында VITE_GOOGLE_CLIENT_ID мәнін көрсетіңіз немесе Flutter көпірі арқылы кіріңіз.',
    },
    support: {
      title: 'Көмек',
      faqTitle: 'Жиі қойылатын сұрақтар',
      faqEmpty: 'Әзірге сұрақтар жоқ',
      contact: 'Байланысу',
      contactHint: 'Сұрағыңыз болса, әкімшіге жазыңыз',
      chatTitle: 'Әкімшімен чат',
      chatLoadError: 'Чатты жүктеу мүмкін болмады',
      chatEmpty: 'Әзірге хабарлар жоқ. Алғашқы хабарыңызды жазыңыз.',
      placeholder: 'Хабар жазыңыз…',
      send: 'Жіберу',
      attach: 'Файл тіркеу',
      removeAttachment: 'Файлды алып тастау',
      imageAlt: 'Тіркелген сурет',
      download: 'Жүктеп алу',
      blocked: 'Сіз бұғатталғансыз — хабарыңыз жіберілмеді',
      blockedBanner: 'Сіз бұғатталғансыз. Хабар жібере алмайсыз.',
      fileTooLarge: 'Файл көлемі 5MB-тан аспауы керек',
      sendError: 'Хабар жіберілмеді',
    },
    supportStaff: {
      title: 'Техникалық көмекшілер',
      contact: 'Байланысу',
      experience: 'Жұмыс өтілі: {{years}} жыл',
      languages: 'Тілдер',
      emptyTitle: 'Әзірге көмекшілер жоқ',
      emptyDescription: 'Техникалық көмекшілер жақында қосылады.',
      error: 'Деректерді жүктеу кезінде қате орын алды',
    },
    notifications: {
      title: 'Хабарламалар',
      emptyTitle: 'Әзірге хабарлама жоқ',
      emptyDescription: 'Жаңа хабарламалар осында көрсетіледі.',
      markAllRead: 'Барлығын оқылды деп белгілеу',
      loadMore: 'Тағы көрсету',
      unread: 'Жаңа',
      imageAlt: 'Хабарлама суреті',
      timeAgo: '{{value}} бұрын',
      justNow: 'жаңа ғана',
      announcementTitle: 'Хабарландыру',
      close: 'Жабу',
      viewReceipt: 'Чекті көру',
    },
    notFound: {
      title: 'Бет табылмады',
      description: 'Сіз іздеген бет жоқ немесе жойылған.',
      goHome: 'Басты бетке',
    },
    tracking: {
      title: 'Бақылау',
      inputLabel: 'Трек-нөмір',
      inputPlaceholder: 'ABC123456',
      submit: 'Тексеру',
      submitSave: 'Сақтау',
      resultLabel: 'Трек-нөмір',
      loadError: 'Күйін тексеру мүмкін болмады',
      save: 'Сақтау',
      unsave: 'Сақталғандардан алып тастау',
      savedBadge: 'Сақталған',
      savedListTitle: 'Сақталған трек-нөмірлер',
      savedEmpty: 'Әзірге ештеңе сақталмаған',
      removeSaved: 'Тізімнен алып тастау',
      confirmRemoveTitle: 'Трек-нөмірді сақталғандардан алып тастайсыз ба?',
      confirmRemoveDescription: '{{trekId}} сақталған тізімнен алып тасталады.',
      errors: {
        invalidFormat: 'Тек әріптер мен цифрлар (5–255 таңба)',
      },
      state: {
        not_found: 'Табылмады',
        waiting: 'Күтілуде',
        collecting: 'Жиналуда',
        in_party: 'Партияда',
      },
      hint: {
        not_found: 'Бұл трек-нөмір қоймаға түспеген.',
        waiting: 'Қоймаға түсті, бірақ иесі әлі сәлемдеме құрмаған.',
        collecting: 'Клиент жөнелтуді растады.',
        in_party: 'Сәлемдеме партияда.',
      },
      toast: {
        saved: 'Трек-нөмір сақталды',
        removed: 'Трек-нөмір тізімнен алып тасталды',
      },
    },
    receipt: {
      paid: 'Төленді',
      brandTagline: 'Жапониядан Өзбекстанға сенімді жеткізу',
      receiptNumber: 'Чек нөмірі',
      date: 'Күні',
      customer: 'Клиент',
      cargoId: 'Cargo ID',
      parcel: 'Сәлемдеме',
      trekId: 'Трек-нөмір',
      service: 'Қызмет',
      downloadPdf: 'PDF жүктеп алу',
      back: 'Артқа',
      footer: 'Ресми төлем чегі · Tez Cargo',
      notFoundTitle: 'Чек табылмады',
      notFoundDescription: 'Мұндай чек жоқ немесе сілтеме қате.',
      loadError: 'Чекті жүктеу мүмкін болмады',
      retry: 'Қайталау',
    },
    payments: {
      title: 'Төлемдер тарихы',
      subtitle: 'Барлық төлем чектеріңіз',
      view: 'Көру',
      pdf: 'PDF',
      number: 'Чек №{{number}}',
      emptyTitle: 'Төлемдер жоқ',
      emptyDescription: 'Төлемдеріңіз осында көрсетіледі.',
      viewAll: 'Барлығын көру',
      loadError: 'Чектерді жүктеу мүмкін болмады',
      retry: 'Қайталау',
    },
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'uz',
    supportedLngs: ['uz', 'ru', 'en', 'kk'],
    ns: [
      'common',
      'nav',
      'regions',
      'parcelStatus',
      'fulfillment',
      'partyStatus',
      'clientStatus',
      'parcels',
      'parcelDetail',
      'parcelForm',
      'claim',
      'cargoId',
      'declaration',
      'profile',
      'settings',
      'onlineAddress',
      'addresses',
      'splits',
      'support',
      'login',
      'notifications',
      'notFound',
      'tracking',
      'packages',
      'receipt',
      'payments',
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'jc_client_lang',
      caches: ['localStorage'],
    },
  });

/** Keep <html lang> in sync with the UI language (screen readers, hyphenation, fonts). */
const syncDocumentLang = (lng?: string): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = (lng ?? 'uz').split('-')[0] || 'uz';
};
syncDocumentLang(i18n.resolvedLanguage ?? i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
